/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/users/collection/products": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询我创建的商品主体
         * @description 查询商品收藏夹 Created / 我创建的商品主体列表
         */
        get: operations["listMyProducts"];
        /**
         * 编辑商品主体
         * @description 编辑商品收藏夹 Created / 我创建的商品主体
         */
        put: operations["updateProduct"];
        /**
         * 创建商品主体
         * @description 保存商品链接解析结果或手动录入内容到商品收藏夹 Created / 我创建的商品主体库
         */
        post: operations["createProduct"];
        /**
         * 删除商品主体
         * @description 软删除商品收藏夹 Created / 我创建的商品主体
         */
        delete: operations["deleteProduct"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/character-assets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询角色资产列表
         * @description 分页查询当前用户的角色资产，前端默认传 MODEL，切换 Animals 时传 ANIMAL；name 为可选名称模糊搜索。
         */
        get: operations["listCharacterAssets"];
        /**
         * 修改角色资产名称
         * @description 修改当前用户角色资产的名称，不影响封面图与平台绑定结果。
         */
        put: operations["renameCharacterAsset"];
        /**
         * 创建角色资产
         * @description 通过 multipart 一次提交角色分类、名称、主图和其他视角图，创建成功后会异步发起 ModelArk 绑定。
         */
        post: operations["createCharacterAsset"];
        /**
         * 删除角色资产
         * @description 软删除当前用户的角色资产，不进入现有素材库回收站。
         */
        delete: operations["deleteCharacterAsset"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/video-creation-option": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * 更新视频创作选项配置
         * @description 将视频创作选项写入 S3（production/front-options/video-creation-option.json）并立即刷新；该配置主要用于前端展示与交互，不作为后端最终提交真理源。
         */
        put: operations["updateVideoCreationOption"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/suppliers-priority": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /**
         * 更新供应商配置（启用+优先级）
         * @description 将各模型下的启用与优先级写入 S3（{profile}/critical-config/suppliers-priority.json）并立即刷新。body：模型 ID → { priority: [ 供应商ID 有序 ] }，如 sora2、sora2-pro-20、seedance-2.0-fast、seedance-2.0。
         */
        put: operations["updateSuppliersPriority"];
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/script-generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频生成的脚本
         * @description 根据请求ID获取已生成的视频脚本信息，支持通过收藏ID查询，支持翻译功能
         */
        get: operations["getGenerateVideoScript"];
        put?: never;
        /**
         * 视频脚本生成
         * @description 提交视频脚本生成任务，返回任务状态码。返回状态码：0-开始任务，1-任务进行中，2-任务结束，3-AI超时，4-无剩余权益，5-无效参数，6-资源未就绪，7-不支持
         */
        post: operations["submitAsyncScript"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/script-analysis": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频脚本解析结果
         * @description 根据视频ID获取视频脚本解析结果，支持翻译功能。脚本解析是将视频的音频内容转换为文字脚本
         */
        get: operations["getScriptAnalysisResult"];
        put?: never;
        /**
         * 发起视频脚本解析任务
         * @description 异步发起视频脚本解析任务，返回任务状态码。脚本解析是将视频的音频内容转换为文字脚本。返回状态码：0-开始任务，1-任务进行中，2-任务结束，3-AI超时，4-无剩余权益，5-无效参数，6-资源未就绪，7-不支持
         */
        post: operations["startScriptAnalysis"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/remake": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 视频复刻
         * @description 根据参考视频、商品图片和商品信息发起视频复刻。必传 videoUrl、videoSource。上传：videoUrl + videoAssetId + videoSource=Kaloclip；外链：先 link-preview，再传 originVideoLink + videoSource + videoId。外部链接会导入为用户资产后入队。
         */
        post: operations["startVideoRemake"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/remake/credit-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 视频复刻需要消耗的积分展示
         * @description 根据参考视频和清晰度返回视频复刻预计积分，仅用于前端展示。后端会解析参考视频实际时长，上传视频优先读资产元数据，外链视频会读取对应 CDN/S3 文件并缓存结果。最终以创建任务时后端解析的实际时长为准。
         */
        post: operations["videoRemakeCreditConsume"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/reference-script": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取参考带货视频脚本
         * @description 基于用户输入的商品，到 Kalodata 寻找优秀的带货视频脚本，生成视频参考脚本文本
         */
        post: operations["buildReferencePromotion"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/recreation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 视频重创作
         * @description 基于原任务（jobId）的所有输入参数，发起一次全新的视频创作。前端需显式传 internalModelId；服务端会按当前路由配置校验该模型是否仍可提交，并重新校验队列额度。
         */
        post: operations["recreateVideoCreation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/link-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取视频链接预览
         * @description 根据视频链接获取预览信息（封面、描述等），不触发真实视频/下载，用于快速预览视频信息
         */
        post: operations["getVideoLinkPreview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/creation": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 视频创作
         * @description 根据已上传图片的 S3 URI（/video/upload-images 返回）、参考脚本文本（/video/reference-script 返回）及视频参数（比例、时长、条数、清晰度）发起视频创作。会校验队列额度与积分。
         */
        post: operations["startVideoCreation"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/creation/credit-preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 视频创作需要消耗的积分展示
         * @description 根据条件，返回当前排列组合下的视频创作积分消耗，供前端展示。条件包括：图片数量、视频时长、视频清晰度、视频数量等。前端在发起创作请求前调用此接口，展示预计消耗积分，用户确认后再调用 /video/creation 接口发起创作。计算规则与扣减时使用的 VideoCreationCreditQuantityResolver 一致。
         */
        post: operations["videoCreationCreditConsume"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/trash": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询回收站列表（已废弃）
         * @deprecated
         * @description 请使用 GET /api/user-assets/trash 替代，新接口 VID 类型通过 vidExtra 返回封面图与时长。
         */
        get: operations["listTrashAssets"];
        put?: never;
        /**
         * 移入回收站
         * @description 将指定资产移入回收站，仅本人可操作。已回收或已删除的资产调用本接口无副作用。
         */
        post: operations["moveToTrash"];
        /**
         * 从回收站永久删除
         * @description 将指定资产从回收站永久删除（标记为已删除），仅本人可操作。非回收站状态的资产调用本接口无副作用。
         */
        delete: operations["deleteFromTrash"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/trash/restore": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 从回收站恢复
         * @description 将指定资产从回收站恢复为正常状态，仅本人可操作。非回收站状态的资产调用本接口无副作用。
         */
        post: operations["restoreFromTrash"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/publish/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 提交视频发布
         * @description 落 INIT 记录后立即返回；后端异步推进上传 → 预检。之后前端用 /result 轮询状态。
         */
        post: operations["submit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/publish/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 确认发布
         * @description 仅在状态为 PRE_CHECK_SUCCESS（预检通过但存在质量 issues 的二次确认场景）时允许调用；同步调发布接口，成功后状态变为 PUBLISHING。若用户指定了未来的 publishTime，状态将迁移为 PENDING_PUBLISH。
         */
        post: operations["confirm"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/publish/cancel": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 取消预约发布
         * @description 仅在状态为 PENDING_PUBLISH（预约发布待到点）时允许调用；取消后记录会迁移到独立的 CANCEL 终态（非 FAIL），便于前端把「用户主动取消」与「系统失败」区分展示。
         */
        post: operations["cancel"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/profile": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取当前用户信息
         * @description 获取当前登录用户的详细信息，需要认证
         */
        get: operations["getCurrentUser"];
        put?: never;
        /**
         * 获取当前用户信息
         * @description 获取当前登录用户的详细信息，需要认证
         */
        post: operations["modifyProfile"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/open-api-key/device-flow/confirm": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Authorize CLI login (called by /cli-login's JS)
         * @description POST from the /cli-login page with Authorization: Bearer <jwt>. Server derives apiKey from userId and stashes it in Redis under the seed (TTL 10min). CLI then picks it up via GET /api/open/v1/device-flow/poll.
         */
        post: operations["confirm_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/modify-avatar": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传用户头像
         * @description 上传用户头像图片，文件大小限制为2MB，支持JPEG、PNG、GIF、WebP格式
         */
        post: operations["modifyAvatar"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/media-agreement": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询媒体协议状态
         * @description 已同意时仅返回 agreed=true、currentVersion 等，不带条款列表；未同意时返回 agreed=false、currentVersion 及完整协议条款列表，供前端弹窗展示，同意接口需携带 currentVersion。
         */
        get: operations["getMediaAgreement"];
        put?: never;
        /**
         * 同意媒体协议
         * @description 用户勾选所有条款后点击 Accept 按钮调用此接口。系统会记录用户IP、浏览器特征、时间、协议版本等信息作为法律依据。
         */
        post: operations["acceptMediaAgreement"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/link/unbind": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 解绑关联账号
         * @description 将指定关联记录标记为已删除（软删除），仅可操作当前用户自己的记录
         */
        post: operations["unbind"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/collection/status": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 查询收藏状态
         * @description 根据关键词查询收藏是否存在，返回状态：true-已收藏，false-未收藏
         */
        post: operations["queryStatus"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/collection/save": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 保存收藏
         * @description 保存视频或脚本到用户收藏列表，支持收藏数量限制（最多100条）和重复检查
         */
        post: operations["save"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/collection/queryList": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 查询收藏列表
         * @description 根据类型查询用户的收藏列表，支持视频和脚本两种类型
         */
        post: operations["queryList"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/ai-jobs/resubmit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 重新提交 Job
         * @description 重新提交指定的视频创作作业，仅本人可操作；需显式传 internalModelId，服务端会按当前路由配置校验该模型是否仍可提交。
         */
        post: operations["resubmitAiJobs"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user-assets/upload-video": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传视频资产
         * @description 上传用户手动选择的 mp4/mov/avi 视频，限制 100MB、120 秒以内。上传成功后登记为 VID + USER 资产，并计入用户存储空间。
         */
        post: operations["uploadVideo"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/upload-images-by-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 按 URL 上传图片资产
         * @description 请求体为 URL 对象数组 [{"url":"https://img.kalocdn.com/xxx.png","description":"white shoes"}]。兼容旧路径 /api/video/upload-images-by-url，建议使用 /api/user-assets/upload-images-by-url。
         */
        post: operations["uploadImagesByUrl"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user-assets/upload-images-by-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 按 URL 上传图片资产
         * @description 请求体为 URL 对象数组 [{"url":"https://img.kalocdn.com/xxx.png","description":"white shoes"}]。兼容旧路径 /api/video/upload-images-by-url，建议使用 /api/user-assets/upload-images-by-url。
         */
        post: operations["uploadImagesByUrl_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/upload-images": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传图片资产
         * @description 上传 1~6 张图片到 S3，返回每项的 assetId、imageUrl。兼容旧路径 /api/video/upload-images，建议使用 /api/user-assets/upload-images。
         */
        post: operations["uploadImages"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user-assets/upload-images": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传图片资产
         * @description 上传 1~6 张图片到 S3，返回每项的 assetId、imageUrl。兼容旧路径 /api/video/upload-images，建议使用 /api/user-assets/upload-images。
         */
        post: operations["uploadImages_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/translation/translate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 文本翻译
         * @description 使用Google翻译服务将文本翻译为目标语言
         */
        post: operations["translate"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/token/refresh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 刷新访问令牌
         * @description 使用 refreshToken 刷新 accessToken。refreshToken 从 httpOnly cookie 读取（必需），currentAccessToken 从 Authorization header 读取（可选）。成功时返回新的 accessToken 和用户信息，新的 refreshToken 通过 httpOnly cookie 返回。如果 refreshToken 已过期或格式错误返回 401，业务逻辑无效（被撤销、频率限制等）返回 200 但 success=false。如果 accessToken 还有超过 5 分钟有效期，不会刷新，直接返回原 accessToken。
         */
        post: operations["refreshToken"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/report/submit": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 提交问题上报
         * @description 同一 asset 仅可上报一次。若本月仍有退积分额度且资产未下载，则退积分、写入记录并将资产标为已退还；若额度用尽、jobType 无退积分配额或资产已下载，则仅写入留痕且资产保持正常。当前仅 VIDEO_CREATION 支持退积分配额。
         */
        post: operations["submitReport"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/parse-info-by-link": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 从商品链接获取信息
         * @description 输入 TikTok、Kalodata 或 Amazon 商品链接，解析并返回商品信息与图片列表
         */
        post: operations["getProductInfoByLink"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/parse-info-by-id": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 从商品 ID 获取信息
         * @description 输入商品 ID，并按 country 入参或缓存国家码查询并返回商品信息与图片列表
         */
        post: operations["getProductInfoById"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/infer-selling-point": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 商品卖点推测
         * @description 根据封面图 URI 和商品名称推测商品卖点
         */
        post: operations["inferProductSellingPoints"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/image-check-and-describe": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 图片检测并增加描述
         * @description 根据商品元数据检测图片合规性，并为合规图片补充描述
         */
        post: operations["checkAndDescribeImages"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取商品详情
         * @description 根据商品ID和国家代码获取商品详情
         */
        post: operations["getDetail"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/attribute": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取TikTok商品属性
         * @description 根据商品ID获取TikTok商品属性信息，支持按属性key查询单个属性
         */
        get: operations["getProductAttribute"];
        put?: never;
        /**
         * 生成TikTok商品属性
         * @description 异步生成TikTok商品属性信息。返回状态码：0-开始任务，1-任务进行中，2-任务结束，3-AI超时，4-无剩余权益，5-无效参数，6-资源未就绪，7-不支持
         */
        post: operations["generateProductAttribute"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/videos": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 发起视频创作
         * @description 提交视频创作任务，返回 jobId 用于后续查询状态
         */
        post: operations["startVideoCreation_1"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/videos/preview": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 预览积分消耗
         * @description 计算当前参数组合下的视频创作积分消耗
         */
        post: operations["videoCreationCreditPreview"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/scripts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 异步生成推广脚本
         * @description 提交脚本生成任务，返回 jobId。扣减 2 积分。通过 GET /jobs/{jobId} 轮询结果。
         */
        post: operations["generateReferenceScript"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/products/resolve": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 商品链接解析
         * @description 传入 TikTok 商品页、TikTok 短链或 Kalodata 商品详情链接，后端自动解析 productId、拉取商品详情、抓取商品图并入当前用户资产库、查询卖点（若已完成属性分析）。返回字段与 /scripts、/videos 请求体对齐，可直接铺进下一步调用。不扣积分；鉴权同其他 Open API 接口（X-API-Key header）。
         */
        post: operations["resolve"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/images": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 上传创作图片
         * @description 上传 1~6 张图片，返回 assetId 和 imageUrl
         */
        post: operations["uploadImages_2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/images/import": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 按 URL 导入图片
         * @description 传入互联网图片 URL 列表，下载并上传到创作资源
         */
        post: operations["uploadImagesByUrl_2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/oauth2/kalo": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Kalodata SSO 登录
         * @description 使用 kalodata.com 的 token 登录到 kaloclip.com。类似 OAuth2 登录流程，登录成功后返回 accessToken，refreshToken 通过 httpOnly cookie 返回
         */
        post: operations["kalodataLogin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/oauth2/google": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["googleOAuth2Login"];
        put?: never;
        /**
         * 验证 Google ID Token（客户端流程）
         * @description 验证 Google 返回的 ID Token（用于客户端 OAuth2 流程和 One Tap），创建或更新用户，返回 JWT token。refreshToken 通过 httpOnly cookie 返回。已登录用户无法重复登录。请求体需包含 credential 字段（Google Identity Services 标准格式：{ "credential": "..." }）。
         */
        post: operations["googleLogin"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/logout": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 用户登出
         * @description 使当前用户的所有token失效（踢掉所有设备），将当前 token 和用户的所有 token 加入黑名单，并清除 refreshToken cookie
         */
        post: operations["logout"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 用户登录
         * @description 支持邮箱密码、手机号密码等多种登录方式，登录成功后返回 accessToken，refreshToken 通过 httpOnly cookie 返回。已登录用户无法重复登录。
         */
        post: operations["login"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["log"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/focus/product/queryListV2": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取用户关注的商品列表
         * @description 根据当前登录用户，查询该用户所有已关注的商品信息
         */
        post: operations["queryFocusProductListV2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/focus/focusEntity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 关注实体
         * @description 关注商品、视频等实体
         */
        post: operations["focusEntity"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/focus/cancelEntity": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 取消关注
         * @description 取消关注商品、视频等实体
         */
        post: operations["cancelEntity"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/download/video/script-generate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 导出视频生成的脚本
         * @description 根据请求ID列表导出已生成的视频脚本为Excel文件，支持批量导出多个脚本
         */
        post: operations["downloadGenerateVideoScript"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/download/video/script-analysis": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 下载视频脚本解析结果
         * @description 根据视频ID下载视频脚本解析结果的Excel文件，支持翻译功能
         */
        post: operations["downloadVideoScript"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/devices/invalidate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 撤销指定设备
         * @description 将指定设备的 token 加入黑名单，使该设备无法继续使用。注意：只能撤销当前用户自己的设备
         */
        post: operations["invalidateDevice"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/configurations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 获取配置信息列表
         * @description 根据请求的配置key列表，批量获取配置信息
         */
        post: operations["listConfigurations"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/captcha/verify": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 验证码校验
         * @description verify captcha
         */
        post: operations["verificationCaptcha"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/captcha/sms-send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send captcha
         * @description Send SMS verification code to specified phone number
         */
        post: operations["sendSmsCaptcha"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/captcha/email-send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send captcha
         * @description Send Email verification code to specified phone number
         */
        post: operations["sendEmailCaptcha"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/asset/record-download": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 记录资源下载
         * @description 标记当前用户已下载指定 asset；同一用户同一 asset 重复调用将幂等返回成功
         */
        post: operations["recordDownload"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/user-link/refresh-token-once": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 手动触发用户关联账号 token 刷新
         * @description 在 kaloclip.user-link.token-refresh.enabled=false（各环境默认关闭）或需即时推进时，由管理员手动扫一轮 access_expire_time < now+24h 的未删除账号，按 platform 派发到对应 handler；仍会走分布式锁，避免与定时任务并发。
         */
        post: operations["triggerUserLinkTokenRefresh"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/trial-credit/compensate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 管理员批量补偿新用户试用积分
         * @description 按 userIds 批量补偿新用户试用积分，逐个调用发放逻辑
         */
        post: operations["compensateTrialCredit"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/test/slow-response": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 慢响应测试（70s）
         * @description 休眠 70 秒后返回，用于验证前端超时后是否会 cancel 请求
         */
        post: operations["testSlowResponse"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/rate-limit/clear": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 清理用户限流
         * @description 清除指定用户的所有限流计数，解除限流后该用户可立即再次请求
         */
        post: operations["clearRateLimitForUser"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/publish/poll-once": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 手动触发视频发布轮询
         * @description 在 kaloclip.publish.poll.enabled=false（如 local）或需要即时推进时，由管理员手动扫一轮 PRE_CHECKING / PUBLISHING 记录并按平台派发到对应 handler；仍会走分布式锁，避免与定时任务并发。
         */
        post: operations["triggerUserPublishPoll"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/prompt/reload-all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 立即刷新所有 Prompt 热加载配置
         * @description 立即从 S3 拉取并刷新所有 PromptReloadAbleConfig 类型的 Bean。
         */
        post: operations["reloadAllPromptConfigs"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/invalidate-tokens/{uid}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 管理员撤销用户所有token
         * @description 使指定用户的所有token失效（管理员功能），将用户的所有 token 加入黑名单
         */
        post: operations["invalidateUserTokens"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/admin/assets/trash-cleanup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * 手动检查并清理过期回收站资产
         * @description 传入 assetId 后，若该资产仍在回收站且 trashedAt 已超过 30 天，则按自动清理逻辑永久删除；否则返回 false。
         */
        post: operations["checkAssetTrashCleanup"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/script-rewrite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/image": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/add-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/me": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_4"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/privacy-policy": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_5"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/insight": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_6"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/authorization": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_7"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/index": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_8"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/video": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_9"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/library": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_10"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/script-review": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_11"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/reset-password": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_12"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/tiktok-shop-auth-callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_13"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/video-creating": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_14"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/signup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_15"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/theme": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_16"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/social-publisher": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 前端页面路由
         * @description SPA 所有前端页面路由，认证由前端处理
         */
        get: operations["index_17"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/vi": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/ko": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/pt": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/th": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/ja": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_4"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/id": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_5"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/my": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_6"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/es": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_7"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/zh": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_8"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["ssrIndex_9"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/cli-login": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["loginPage"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/video-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频URL
         * @description 根据视频ID和来源获取视频的播放URL（CDN地址）
         */
        get: operations["getVideoUrl"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/try-example": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取随机示例视频
         * @description 随机获取一条Demo视频的预览信息，用于示例展示。用户点击"Try an Example / 随机试试"按钮时调用
         */
        get: operations["tryExample"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/remake/job-detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频复刻任务详情
         * @description 根据 user_ai_job.id 查询视频复刻任务明细，包含任务基础字段及 inputContext/jobContext/outputContext 的结构化对象。
         */
        get: operations["getVideoRemakeJobDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/product-info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频带货商品
         * @description 获取视频里的带货商品(第一个)
         */
        get: operations["getProductInfoOfVideo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/download-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频的下载链接
         * @description 根据视频ID和来源获取视频的下载链接（CDN地址）
         */
        get: operations["downloadUrl"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频详情
         * @description 根据视频ID获取视频详情
         */
        get: operations["getVideoDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/creation/job-detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频创作任务详情
         * @description 根据 user_ai_job.id 查询任务明细，包含任务基础字段及 inputContext/jobContext/outputContext 的结构化对象。
         */
        get: operations["getVideoCreationJobDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/video/creation-option": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频创作选项
         * @description 返回比例、时长、条数、清晰度等选项及 duration_resolution 规则，并包含每个 duration 下供前端展示的模型列表。
         */
        get: operations["getCreateOption"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/publish/result": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询发布结果
         * @description 按记录 id 查当前用户的发布状态，前端用于轮询。返回字段 needConfirm=true 时，前端应展示质量 issues 等用户点确认。
         */
        get: operations["result"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/publish/page": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 分页查询当前用户发布记录
         * @description 按当前用户维度分页查询发布记录，按记录 id 倒序（即提交时间倒序）。可选按 assetId、status、publishMode、linkId 过滤。
         */
        get: operations["page"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/link/publish-video-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 批量判断各平台是否可以发布视频
         * @description 按 platforms 入参顺序返回每个平台能否发布。各平台的判定规则封装在 UserLinkHandler 实现中。
         */
        get: operations["publishCheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/link/publish-tk-check": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 用户是否可以发布tiktok带货视频（兼容旧接口，建议改用 /publish-video-check）
         * @description 存在 TikTok 关联账号且其 region 满足 TkShopHelper#canPublishVideo 时为 true，否则为 false
         */
        get: operations["publishTkCheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/link/accounts": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 关联账号列表
         * @description 查询当前登录用户已绑定的平台账号（未删除），不分页
         */
        get: operations["list"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/collection/queryDetail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询收藏详情
         * @description 根据收藏ID查询收藏的详细信息
         */
        get: operations["queryDetail"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/collection/products/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询商品主体详情
         * @description 查询商品收藏夹 Created / 我创建的商品主体详情
         */
        get: operations["getProduct"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/collection/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 删除收藏
         * @description 根据收藏ID删除指定的收藏项
         */
        get: operations["delete"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/assets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取用户资产库列表（已废弃）
         * @deprecated
         * @description 请使用 GET /api/user-assets 替代，新接口 VID 类型通过 vidExtra 返回封面图与时长。
         */
        get: operations["listUserAssets"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user-assets": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取用户资产库列表 V2
         * @description 分页查询当前用户资产（图片、视频等），VID 类型在顶层和 vidExtra 中返回封面图，并在 vidExtra 中返回时长及发布状态。可按资产类型和来源筛选。
         */
        get: operations["listUserAssets_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/user-assets/trash": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询回收站列表 V2
         * @description 查询当前用户回收站中的所有资产。该接口返回轻量展示信息，不返回预计完成时间和完整 jobItem；AI 视频资产仅保留商品标题、商品图等回收站展示所需信息。
         */
        get: operations["listTrashAssets_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/tiktok-shop/seller-auth-callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 卖家授权绑定
         * @description 卖家授权绑定
         */
        get: operations["sellerAuthCallBack"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/tiktok-shop/creator-auth-url": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取授权登录url
         * @description 获取授权登录url
         */
        get: operations["getCreatorAuthUrl"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/tiktok-shop/asset-product": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询用户视频资产关联的产品信息
         * @description 查询用户视频资产关联的产品信息
         */
        get: operations["getVideoLinkedProduct"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/tiktok-shop/account-products": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 分页查询用户可选产品列表
         * @description 根据 linkId 所属账号类型分页拉取 TikTok Shop 店铺/橱窗商品，使用 pageToken 游标翻页
         */
        get: operations["listAccountProducts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/report/refund-quota": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询退款次数配额
         * @description 按任务类型查询用户本月剩余退款次数，不同 jobType 配额不同
         */
        get: operations["getRefundQuota"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/product/keyword-search": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 根据关键词搜索TikTok商品
         * @description 使用关键词和国家代码搜索TikTok商品
         */
        get: operations["searchKalodataProducts"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/pay/queryOrder": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 用户订单查询
         * @description 用户订单查询
         */
        get: operations["queryOrder"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/pay/goToPay": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 用户下单购买
         * @description 用户下单购买
         */
        get: operations["goToPay"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/out/tiktok-shop/auth/callback": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 授权登录回调
         * @description 处理 TikTok Shop 授权回调，成功/失败均 302 重定向到前端回调页，结果通过 state 参数携带
         */
        get: operations["authCallBack"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/videos/{jobId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询视频创作任务状态
         * @description 等同于 GET /jobs/{jobId}
         */
        get: operations["getVideoCreationJobStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/videos/queue": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询队列状态
         * @description 返回当前队列长度和预估等待时间
         */
        get: operations["getQueueStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/videos/options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取视频创作选项
         * @description 返回可用的比例、时长、清晰度，以及每个 duration 下供前端展示的模型列表
         */
        get: operations["getCreationOption"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/jobs/{jobId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询任务状态（通用）
         * @description 根据 jobId 查询任意类型任务的状态与结果（视频创作、脚本生成等）
         */
        get: operations["getJobStatus"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/images/options": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取图片上传选项
         * @description 返回允许的图片格式、大小限制和数量限制
         */
        get: operations["getImageOptions"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/device-flow/poll": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * CLI polls for the apiKey
         * @description Public. Path under /api/open/v1/** so Cloudflare WAF lets curl-class clients through. If the seed has been confirmed and written to Redis, returns the apiKey and deletes the entry atomically (one-shot). Else returns {status:"pending"}.
         */
        get: operations["poll"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/open/v1/credits": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询积分余额
         * @description 获取当前 API Key 绑定用户的积分余额
         */
        get: operations["getCredits"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/i18nVersion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取国际化版本
         * @description 获取当前国际化配置的版本号
         */
        get: operations["getI18nVersion"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/focus/products-collection": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取用户关注的商品列表，性能优化后的
         * @description 从 Kvrocks 缓存获取用户已关注的商品信息
         */
        get: operations["listProductsCollection"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/devices": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取活跃设备列表
         * @description 获取当前用户的所有活跃设备列表，包括设备名称、最后使用时间等信息
         */
        get: operations["getDevices"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/credits/logs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取用户积分日志
         * @description 获取当前用户的积分消费和获得记录，支持分页
         */
        get: operations["listCreditLogs"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/credits/check-consumed": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 检查积分是否已消费
         * @description 检查指定内容是否已消耗过积分，未消耗时同时返回当前剩余积分量
         */
        get: operations["checkCredit"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/credits/balance": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取用户剩余积分
         * @description 获取当前用户的积分余额，包括总积分、月度积分和长期积分
         */
        get: operations["getCredits_1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/character-assets/detail": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 查询角色资产详情
         * @description 查询当前用户的单个角色资产详情。
         */
        get: operations["getCharacterAsset"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/asset/state": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 获取资产状态
         * @description 查询当前用户指定 asset 的状态详情
         */
        get: operations["getAssetState"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/asset/downloaded": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * 是否已下载过
         * @description 查询当前用户是否已对指定 asset 记录过下载
         */
        get: operations["isDownloaded"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/users/trash/empty": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post?: never;
        /**
         * 清空回收站
         * @description 将当前用户回收站中的所有资产永久删除（标记为已删除）。
         */
        delete: operations["emptyTrash"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        ResultVoid: {
            success?: boolean;
            data?: unknown;
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultMapStringString: {
            success?: boolean;
            data?: {
                [key: string]: string;
            };
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户商品类目信息 */
        UserProductCategory: {
            /**
             * @description 一级类目 ID
             * @example 100
             */
            priCateId?: string | null;
            /**
             * @description 二级类目 ID
             * @example 200
             */
            secCateId?: string | null;
            /**
             * @description 三级类目 ID
             * @example 300
             */
            terCateId?: string | null;
            /**
             * @description 一级类目名称
             * @example Home Appliances
             */
            priCateName?: string | null;
            /**
             * @description 二级类目名称
             * @example Kitchen Appliances
             */
            secCateName?: string | null;
            /**
             * @description 三级类目名称
             * @example Blenders
             */
            terCateName?: string | null;
            /**
             * @description 类目来源
             * @example AI
             * @enum {string}
             */
            source?: UserProductCategorySource;
        };
        /** @description 用户商品图片信息 */
        UserProductImage: {
            /**
             * @description 图片 URL
             * @example https://cdn.example.com/product/main.png
             */
            url: string;
            /**
             * Format: int64
             * @description 关联的用户图片资产 ID
             * @example 10001
             */
            assetId?: number | null;
            /**
             * @description 图片来源
             * @example KALODATA
             * @enum {string}
             */
            source?: UserProductImageSource;
        };
        /** @description 用户商品卖点 */
        UserProductSellingPoint: {
            /**
             * @description 卖点内容
             * @example USB-C rechargeable
             */
            content: string;
            /**
             * @description 卖点来源
             * @example AI
             * @enum {string}
             */
            source?: UserProductSellingPointSource;
        };
        /** @description 商品主体创建请求 */
        UserProductUpsertRequest: {
            /**
             * @description 商品来源
             * @example KALODATA
             * @enum {string}
             */
            sourceType: UserProductUpsertRequestSourceType;
            /**
             * @description 来源商品 ID，如 TikTok productId 或 Amazon ASIN
             * @example 1730502815821107300
             */
            sourceProductId?: string | null;
            /**
             * @description 来源商品链接
             * @example https://www.kalodata.com/product/detail?id=1730502815821107300&region=US
             */
            sourceUrl?: string | null;
            /**
             * @description 国家代码
             * @example US
             */
            country?: string | null;
            /**
             * @description 商品标题
             * @example Portable Blender
             */
            title: string;
            /** @description 商品主图或正视图 */
            mainImage: components["schemas"]["UserProductImage"];
            /** @description 商品其他视角图片，最多 9 张 */
            images?: components["schemas"]["UserProductImage"][];
            /** @description 商品类目 */
            category: components["schemas"]["UserProductCategory"];
            /** @description 商品卖点，最多 10 个 */
            sellingPoints?: components["schemas"]["UserProductSellingPoint"][];
            /**
             * @description 弱结构扩展信息
             * @example {
             *       "contentSafetyStatus": "PASSED"
             *     }
             */
            metadata?: {
                [key: string]: unknown;
            } | null;
        };
        ResultUserProductResponse: {
            success?: boolean;
            data?: components["schemas"]["UserProductResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户商品主体响应 */
        UserProductResponse: {
            /**
             * Format: int64
             * @description 商品主体 ID
             * @example 3001
             */
            id: number;
            /**
             * @description 商品来源
             * @example KALODATA
             * @enum {string}
             */
            sourceType: UserProductResponseSourceType;
            /**
             * @description 来源商品 ID
             * @example 1730502815821107300
             */
            sourceProductId?: string;
            /**
             * @description 来源商品链接
             * @example https://www.kalodata.com/product/detail?id=1730502815821107300&region=US
             */
            sourceUrl?: string;
            /**
             * @description 国家代码
             * @example US
             */
            country?: string;
            /**
             * @description 商品标题
             * @example Portable Blender
             */
            title: string;
            /** @description 商品主图或正视图 */
            mainImage: components["schemas"]["UserProductImage"];
            /** @description 商品其他视角图片 */
            images: components["schemas"]["UserProductImage"][];
            /** @description 商品类目 */
            category: components["schemas"]["UserProductCategory"];
            /** @description 商品卖点 */
            sellingPoints: components["schemas"]["UserProductSellingPoint"][];
            /**
             * @description 弱结构扩展信息
             * @example {
             *       "contentSafetyStatus": "PASSED"
             *     }
             */
            metadata: {
                [key: string]: unknown;
            };
            /**
             * Format: int64
             * @description 创建时间毫秒时间戳
             * @example 1778653200000
             */
            gmtCreated: number;
            /**
             * Format: int64
             * @description 更新时间毫秒时间戳
             * @example 1778653200000
             */
            gmtUpdated: number;
        };
        /** @description 角色资产改名请求 */
        CharacterAssetRenameRequest: {
            /**
             * @description 新角色名称
             * @example Cat Hero
             */
            name: string;
        };
        /** @description 角色资产图片信息 */
        CharacterAssetImage: {
            /**
             * @description 图片 CDN 地址
             * @example https://resource.kaloclip.com/resources/1001/character/main.png
             */
            imageUrl: string;
        };
        /** @description 角色资产平台绑定摘要 */
        CharacterAssetPlatformSummary: {
            /**
             * @description ModelArk 资产 ID
             * @example asset-20260518152809-6pmtm
             */
            modelArkAssetId?: string;
            /**
             * @description ModelArk 资产 URI
             * @example asset://asset-20260518152809-6pmtm
             */
            modelArkAssetUri?: string;
            /**
             * @description ModelArk 临时资产 URL（历史兼容字段，可能过期）
             * @example https://ark-media-asset.example.com/demo.png
             */
            modelArkAssetUrl?: string;
            /**
             * @description 绑定失败错误码
             * @example MODELARK_TIMEOUT
             */
            errorCode?: string;
            /**
             * @description 绑定失败错误信息
             * @example upstream timeout
             */
            errorMessage?: string;
        };
        /** @description 角色资产响应 */
        CharacterAssetResponse: {
            /**
             * Format: int64
             * @description 角色资产 ID
             * @example 3001
             */
            id: number;
            /**
             * @description 角色分类
             * @example MODEL
             * @enum {string}
             */
            category: CharacterAssetResponseCategory;
            /**
             * @description 角色名称
             * @example Demo Character
             */
            name: string;
            /** @description 角色主图/正视图 */
            mainImage: components["schemas"]["CharacterAssetImage"];
            /** @description 角色其他视角图片 */
            otherImages: components["schemas"]["CharacterAssetImage"][];
            /**
             * @description 平台绑定状态
             * @example BOUND
             * @enum {string}
             */
            bindState: CharacterAssetResponseBindState;
            /** @description 平台绑定摘要 */
            platformSummary?: components["schemas"]["CharacterAssetPlatformSummary"];
        };
        ResultCharacterAssetResponse: {
            success?: boolean;
            data?: components["schemas"]["CharacterAssetResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ModelOptionItem: {
            label: string;
            value: string;
            description?: string;
            default?: boolean;
        };
        OptionItemInteger: {
            label: string;
            /** Format: int32 */
            value: number;
            default?: boolean;
        };
        OptionItemString: {
            label: string;
            value: string;
            default?: boolean;
        };
        Rules: {
            duration_resolution: {
                [key: string]: unknown[];
            };
            duration_model: {
                [key: string]: string[];
            };
            extra?: {
                [key: string]: unknown;
            };
        };
        /** @description 视频创作选项配置 JSON，如比例、时长、条数、清晰度、duration_resolution 规则，以及每个 duration 下前端展示用的 models 列表 */
        VideoCreationOptionConfig: {
            aspectRatioOptions: components["schemas"]["OptionItemString"][];
            durationOptions: components["schemas"]["OptionItemInteger"][];
            quantityOptions: components["schemas"]["OptionItemInteger"][];
            resolutionOptions: components["schemas"]["OptionItemString"][];
            modelOptions: components["schemas"]["ModelOptionItem"][];
            rules: components["schemas"]["Rules"];
            extra?: {
                [key: string]: unknown;
            };
        };
        ResultVideoCreationOptionConfig: {
            success?: boolean;
            data?: components["schemas"]["VideoCreationOptionConfig"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 模型 ID → { priority }，如 {"sora2": {"priority": ["suchuang"]}, "sora2-pro-20": {"priority": ["aijisu"]}, "seedance-2.0-fast": {"priority": ["seedance"]}, "seedance-2.0": {"priority": ["seedance"]}} */
        ModelSupplierConfig: {
            priority?: string[];
        };
        ResultMapStringModelSupplierConfig: {
            success?: boolean;
            data?: {
                [key: string]: components["schemas"]["ModelSupplierConfig"];
            };
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频脚本生成请求，包含视频ID、用户输入内容、请求ID等 */
        VideoScriptGenerateRequest: {
            /**
             * @description 视频ID（可选，如果只传商品信息可以不传）
             * @example 7576839935928356110
             */
            id?: string;
            /**
             * @description requestId(请求唯一标识符)
             * @example 34037e69d75f4
             */
            requestId: string;
            /**
             * @description 视频来源，默认为TikTok
             * @example TikTok
             */
            videoSource?: string;
            /**
             * @description 用户输入内容，如 {"prompt": "带货脚本"}
             * @example {
             *       "prompt": "带货脚本"
             *     }
             */
            userInput: {
                [key: string]: unknown;
            };
        };
        AsyncTaskResponse: {
            /** Format: int32 */
            code?: number;
        };
        ResultAsyncTaskResponse: {
            success?: boolean;
            data?: components["schemas"]["AsyncTaskResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频脚本分析请求，包含视频ID和来源 */
        VideoIdRequest: {
            /**
             * @description 视频ID
             * @example 7583359920158903565
             */
            id: string;
            /**
             * @description 视频来源，默认为TikTok
             * @example TikTok
             */
            videoSource?: string;
        };
        /** @description 视频任务商品图片信息 */
        ImageDescriptionInfo: {
            /**
             * Format: int64
             * @description 图片资产 ID，由上传图片接口返回，须为本人资产
             * @example 1
             */
            assetId: number;
            /**
             * @description 图片 CDN 地址，由上传图片接口返回
             * @example https://resource.kaloclip.com/resources/1/upload/img_abc.png
             */
            imageUrl: string;
            /**
             * @description 图片描述（可选）
             * @example A product shot on a clean background.
             */
            description?: string;
        };
        /** @description 视频复刻请求。videoUrl 必传：上传传 upload 返回的 CDN；外链传 link-preview 的 originVideoLink。手动上传时另传 videoAssetId + videoSource=Kaloclip；外链另传 link-preview 的 videoSource、videoId，后端仅临时读取参考视频，不写入用户资产库 */
        VideoRemakeRequest: {
            /**
             * @description 参考视频 URL，必传。上传场景=upload-video 返回的 videoUrl；外链场景=POST /video/link-preview 返回的 originVideoLink
             * @example https://resource.kaloclip.com/resources/373554/upload/VIDGG9qjAVeVLwmpdrahfz.mp4
             */
            videoUrl: string;
            /**
             * Format: int64
             * @description 参考视频用户资产 ID。手动上传场景必传（= upload-video 返回的 assetId）；外链场景不传
             * @example 207630
             */
            videoAssetId?: number;
            /**
             * @description 外链平台侧视频 ID。外链场景传 link-preview 返回的 videoId；上传场景不传
             * @example 7312345678901234567
             */
            videoId?: string;
            /**
             * @description 参考视频来源，必传。上传传 Kaloclip；外链传 link-preview 返回的 videoSource
             * @example Kaloclip
             * @enum {string}
             */
            videoSource: VideoRemakeRequestVideoSource;
            /**
             * @description 商品图片地址列表，由 /video/upload-images 或 /video/upload-images-by-url 返回
             * @example [
             *       {
             *         "assetId": 1,
             *         "imageUrl": "https://resource.kaloclip.com/resources/1/upload/img_abc.png"
             *       }
             *     ]
             */
            imageInfos: components["schemas"]["ImageDescriptionInfo"][];
            /**
             * Format: int64
             * @description 角色资产 ID，对应 CharacterAssetDO.id，可选
             * @example 3001
             */
            characterAssetId?: number;
            /**
             * @description 视频比例，默认 9:16
             * @example RATIO_9_16
             * @enum {string}
             */
            aspectRatio: VideoRemakeRequestAspectRatio;
            /**
             * Format: int32
             * @description 生成条数，本期仅支持 1
             * @example 1
             * @enum {integer}
             */
            quantity?: VideoRemakeRequestQuantity;
            /**
             * @description 视频清晰度，默认 720P；1080P 本期先按 720P 生成并按复刻规则计费
             * @example 720P
             * @enum {string}
             */
            resolution: VideoRemakeRequestResolution;
            /**
             * @description 内部模型 ID，不传默认 sd2；视频复刻当前仅支持 sd2/sd2f
             * @default sd2
             * @example sd2
             * @enum {string}
             */
            internalModelId: VideoRemakeRequestInternalModelId;
            /**
             * @description 产品标题，作为视频内容
             * @example Wireless Earbuds
             */
            productTitle: string;
            /**
             * @description 商品 ID；TikTok/Kalodata 场景传数字型 productId，Amazon 场景传 ASIN
             * @example 1234567890
             */
            productId: string;
            /**
             * @description 商品归属国家参数代码，可选
             * @example US
             */
            productCountry?: string;
            /**
             * @description 类目名称列表
             * @example [
             *       "Electronics",
             *       "Audio"
             *     ]
             */
            categoryNames?: string[];
            /**
             * @description 卖点列表
             * @example [
             *       "Noise Cancelling",
             *       "30hr Battery"
             *     ]
             */
            sellingPoints?: string[];
            /**
             * @description 用户输入的提示词，可选，最长 300 字符
             * @example Keep the same pacing and replace the product in every shot.
             */
            userInputPrompt?: string;
            /**
             * @description 售卖国家参数代码
             * @example US
             */
            sellingCountry?: string;
            /**
             * @description 视频语言
             * @example en
             */
            language?: string;
        };
        ResultString: {
            success?: boolean;
            data?: string;
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频复刻积分试算请求 */
        VideoRemakeCreditPreviewRequest: {
            /**
             * @description 参考视频 URL。上传场景=upload-video 返回的 videoUrl；外链场景=POST /video/link-preview 返回的 originVideoLink
             * @example https://resource.kaloclip.com/resources/373554/upload/VIDGG9qjAVeVLwmpdrahfz.mp4
             */
            videoUrl: string;
            /**
             * Format: int64
             * @description 参考视频用户资产 ID。手动上传场景必传；外链场景不传
             * @example 207630
             */
            videoAssetId?: number;
            /**
             * @description 参考视频来源。上传传 Kaloclip；外链传 link-preview 返回的 videoSource
             * @example Kaloclip
             * @enum {string}
             */
            videoSource: VideoRemakeCreditPreviewRequestVideoSource;
            /**
             * @description 视频清晰度
             * @example 720P
             * @enum {string}
             */
            resolution: VideoRemakeCreditPreviewRequestResolution;
        };
        ResultInteger: {
            success?: boolean;
            /** Format: int32 */
            data?: number;
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 生成参考脚本需要的参数，包含 imagePaths 等 */
        BuildVideoReferenceScriptRequest: {
            /**
             * @description 图片地址列表，由 /video/upload-images 接口返回；其中 description 会在 Seedance 场景自动转换为参考素材描述
             * @example [
             *       {
             *         "assetId": 1,
             *         "imageUrl": "www.xx.net/123/img_abc.png",
             *         "description": "The male CEO wearing a suit."
             *       }
             *     ]
             */
            imageInfos: components["schemas"]["ImageDescriptionInfo"][];
            /**
             * @description 商品名称，当 productId 不存在的时候模糊搜索用
             * @example Wireless Bluetooth Earbuds
             */
            productTitle: string;
            /**
             * @description 类目名称列表
             * @example [
             *       "Electronics",
             *       "Audio"
             *     ]
             */
            categoryNames: string[];
            /**
             * @description 卖点列表
             * @example [
             *       "Noise Cancelling",
             *       "30hr Battery"
             *     ]
             */
            sellingPoints?: string[];
            /**
             * @description 创作的视频要求，可选，最长 300 字符
             * @example Create a trendy TikTok video showcasing the wireless earbuds, highlighting their noise cancelling feature and long battery life. Use upbeat music and include text overlays with the key selling points.
             */
            creationDescription?: string;
            /**
             * @description 商品 id；TikTok/Kalodata 场景传数字型 productId，Amazon 场景传 ASIN
             * @example 1729382256913203941
             */
            productId?: string;
            /**
             * @description 商品归属国家
             * @example US
             */
            country?: string;
            /**
             * @description 售卖国家参数代码
             * @example Unite State
             */
            sellingCountry?: string;
            /**
             * @description 视频语言
             * @example en
             */
            language: string;
            /**
             * Format: int32
             * @description 视频时长，单位秒，需与所选 internalModelId 的时长一致
             * @default 15
             * @example 15
             */
            duration: number;
            /**
             * @description 内部模型 ID；前端通常从 creation-option 读取，服务端会校验当前路由配置是否仍可提交
             * @example sd2f
             * @enum {string}
             */
            internalModelId: BuildVideoReferenceScriptRequestInternalModelId;
        };
        /** @description 视频重创作请求 */
        VideoRecreationRequest: {
            /**
             * Format: int64
             * @description 原任务主键 user_ai_job.id
             * @example 78
             */
            jobId: number;
            /**
             * @description 用户最终确认的内部模型 ID；前端通常从 creation-option 读取，服务端会按当前路由配置校验是否仍可提交
             * @example sd2f
             * @enum {string}
             */
            internalModelId: VideoRecreationRequestInternalModelId;
        };
        /** @description 视频链接预览请求，包含视频链接URL */
        VideoLinkPreviewRequest: {
            /**
             * @description 视频链接 URL
             * @example https://www.tiktok.com/@user/video/1234567890
             */
            videoLink: string;
        };
        ResultVideoLinkPreviewResponse: {
            success?: boolean;
            data?: components["schemas"]["VideoLinkPreviewResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频链接预览响应 */
        VideoLinkPreviewResponse: {
            /** @description 原始视频链接 */
            originVideoLink?: string;
            /** @description 封面图片URL */
            coverImageUrl?: string;
            /** @description 视频描述 */
            description?: string;
            /** @description 视频来源平台（TikTok/YouTube） */
            videoSource?: string;
            /** @description 视频ID */
            videoId?: string;
            /** @description 国家代码 */
            country?: string;
            /** @description 是否有带货商品 */
            hasProduct?: boolean;
        };
        /** @description 视频创作请求，需先调用上传接口获取 imageUris、参考脚本接口获取 referenceScript */
        VideoCreationRequest: {
            /**
             * @description 视频比例，默认 9:16
             * @example RATIO_9_16
             * @enum {string}
             */
            aspectRatio: VideoCreationRequestAspectRatio;
            /**
             * Format: int32
             * @description 视频时长（秒），需与所选 internalModelId 的时长一致
             * @example 15
             * @enum {integer}
             */
            duration: VideoCreationRequestDuration;
            /**
             * Format: int32
             * @description 生成条数，本期仅支持 1
             * @example 1
             * @enum {integer}
             */
            quantity?: VideoCreationRequestQuantity;
            /**
             * @description 视频清晰度，默认 720P；480P 仅部分模型支持；1080P 时服务端超分
             * @example 720P
             * @enum {string}
             */
            resolution: VideoCreationRequestResolution;
            /**
             * @description 内部模型 ID；前端通常从 creation-option 读取，服务端会校验当前路由配置是否可提交
             * @example sd2f
             * @enum {string}
             */
            internalModelId: VideoCreationRequestInternalModelId;
            /**
             * @description 图片地址列表，由 /video/upload-images 接口返回
             * @example [
             *       "www.xx.net/123/img_abc.png"
             *     ]
             */
            imageInfos: components["schemas"]["ImageDescriptionInfo"][];
            /**
             * @description script 对应的某次请求 id；当 referenceScript 为空时，后端会根据 requestId 自动查询并回填参考脚本
             * @example 3xxxx
             */
            requestId?: string;
            /**
             * Format: int32
             * @description activeScript, 生效的脚本
             * @example 1
             */
            activeScript?: number;
            /**
             * @description 国家参数代码
             * @example US
             */
            country?: string;
            /**
             * @description 视频语言
             * @example en
             */
            language: string;
            /**
             * @description 参考脚本文本，由 /video/reference-script 接口返回
             * @example A sleek product shot of wireless earbuds on a minimal background, soft lighting.
             */
            originScript?: string;
            /** @description 用户修改后的脚本，可以为空，为空后端认为和参考脚本一样 */
            userModifiedScript?: string;
            /**
             * @description 产品标题，作为视频内容
             * @example Wireless Earbuds
             */
            productTitle: string;
            /**
             * @description 商品 ID
             * @example 1234567890
             */
            productId?: string;
            /**
             * @description 类目名称列表
             * @example [
             *       "Electronics",
             *       "Audio"
             *     ]
             */
            categoryNames: string[];
            /**
             * @description 卖点列表
             * @example [
             *       "Noise Cancelling",
             *       "30hr Battery"
             *     ]
             */
            sellingPoints?: string[];
            /**
             * @description 创作的视频要求，可选，最长 300 字符
             * @example Create a trendy TikTok video showcasing the wireless earbuds, highlighting their noise cancelling feature and long battery life. Use upbeat music and include text overlays with the key selling points.
             */
            creationDescription?: string;
            /**
             * @description 售卖国家参数代码
             * @example US
             */
            sellingCountry?: string;
        };
        /** @description 积分试算请求：aspectRatio、duration(8/12/15/20)、quantity、resolution */
        BaseVideoCreationOptionRequest: {
            /**
             * @description 视频比例，默认 9:16
             * @example RATIO_9_16
             * @enum {string}
             */
            aspectRatio: BaseVideoCreationOptionRequestAspectRatio;
            /**
             * Format: int32
             * @description 视频时长（秒），需与所选 internalModelId 的时长一致
             * @example 15
             * @enum {integer}
             */
            duration: BaseVideoCreationOptionRequestDuration;
            /**
             * Format: int32
             * @description 生成条数，本期仅支持 1
             * @example 1
             * @enum {integer}
             */
            quantity?: BaseVideoCreationOptionRequestQuantity;
            /**
             * @description 视频清晰度，默认 720P；480P 仅部分模型支持；1080P 时服务端超分
             * @example 720P
             * @enum {string}
             */
            resolution: BaseVideoCreationOptionRequestResolution;
            /**
             * @description 内部模型 ID；前端通常从 creation-option 读取，服务端会校验当前路由配置是否可提交
             * @example sd2f
             * @enum {string}
             */
            internalModelId: BaseVideoCreationOptionRequestInternalModelId;
        };
        /** @description 通用 ID 请求，请求体仅包含 id 字段 */
        IdRequestLong: {
            /**
             * Format: int64
             * @description 资源 ID
             * @example 123456789
             */
            id: number;
        };
        /** @description 提交视频发布请求 */
        UserPublishSubmitRequest: {
            /**
             * Format: int64
             * @description 关联账号 id（user_link_account.id）
             * @example 1001
             */
            linkId: number;
            /**
             * Format: int64
             * @description 视频资产 id（clip_user_asset.id）
             * @example 2001
             */
            assetId: number;
            /**
             * @description 平台，非必填，默认TIKTOK
             * @example TIKTOK
             */
            platform?: string;
            /**
             * @description 发布模式：NOW=立即发布，SCHEDULE=定时发布
             * @example NOW
             * @enum {string}
             */
            publishMode: UserPublishSubmitRequestPublishMode;
            /**
             * @description 商品 id（TikTok product_id）
             * @example 17294069642063424
             */
            productId: string;
            /**
             * @description 商品标题，用于发布记录展示
             * @example Wireless Earbuds
             */
            productTitle: string;
            /**
             * @description 商品图片 URL；提交发布前会同步下载并镜像到 S3
             * @example https://p16-oec-va.ibyteimg.com/tos-maliva-i-o3syd03w52-us/example.png
             */
            productImage?: string;
            /**
             * @description 商品锚点文案（TikTok product_link_info.title），≤ 30 字符
             * @example Sample product anchor title
             */
            title: string;
            /**
             * @description 视频 caption（TikTok video_info.title），≤ 4000 字符
             * @example Try this amazing product!
             */
            description: string;
            /**
             * @description 是否在发布前进行预校验；仅当显式为 true 时走预检，null 或 false 均跳过预检直接进入发布阶段
             * @example false
             */
            needPrecheck?: boolean;
            /**
             * Format: int64
             * @description 发布时间（毫秒时间戳）。publishMode=NOW 时会被服务端忽略并改写为当前时间；publishMode=SCHEDULE 时必填，最多支持当前时间 + 30 天。
             * @example 1745712000000
             */
            publishTime?: number;
        };
        ResultUserPublishSubmitResponse: {
            success?: boolean;
            data?: components["schemas"]["UserPublishSubmitResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 提交发布响应 */
        UserPublishSubmitResponse: {
            /**
             * Format: int64
             * @description 发布记录 id，后续轮询 /result 与 /confirm 使用
             * @example 3001
             */
            id: number;
            /**
             * @description 初始状态（预期为 INIT，前端直接开始轮询即可）
             * @example INIT
             */
            status: string;
        };
        /** @description 确认发布请求（仅用于预检通过但有质量 issues 的二次确认） */
        UserPublishConfirmRequest: {
            /**
             * Format: int64
             * @description 发布记录 id
             * @example 3001
             */
            id: number;
        };
        /** @description 取消预约发布请求（仅允许 PENDING_PUBLISH 状态） */
        UserPublishCancelRequest: {
            /**
             * Format: int64
             * @description 发布记录 id
             * @example 3001
             */
            id: number;
        };
        /** @description 修改用户资料请求，至少填写一个字段 */
        ModifyUserProfileRequest: {
            /**
             * @description 语言代码
             * @example zh-CN
             */
            language?: string;
            /**
             * @description 新密码
             * @example ******
             */
            password?: string;
            /**
             * @description 名
             * @example San
             */
            firstName?: string;
            /**
             * @description 姓
             * @example Zhang
             */
            lastName?: string;
        };
        ResultMapStringObject: {
            success?: boolean;
            data?: {
                [key: string]: unknown;
            };
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 接受媒体协议请求，用户必须勾选所有条例后才能提交 */
        AcceptMediaAgreementRequest: {
            /**
             * Format: int32
             * @description 协议版本号（int），由前端从 GET /api/users/media-agreement 的 currentVersion 获取
             * @example 1
             */
            version: number;
        };
        ResultUserCollectionStatusResponse: {
            success?: boolean;
            data?: components["schemas"]["UserCollectionStatusResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户收藏状态响应 */
        UserCollectionStatusResponse: {
            /**
             * Format: int64
             * @description 收藏ID
             */
            collectionId?: number;
            /**
             * @description 收藏状态
             * @example true
             */
            status?: boolean;
        };
        /** @description 收藏查询请求，包含类型（1=视频，2=脚本） */
        UserCollectionRequest: {
            /**
             * @description 关键词（可选）
             * @example 带货
             */
            keyword?: string;
            /**
             * Format: int32
             * @description 类型：1=视频，2=视频脚本
             * @example 1
             * @enum {integer}
             */
            type: UserCollectionRequestType;
            /**
             * @description 扩展参数（可选）
             * @example {}
             */
            params?: {
                [key: string]: unknown;
            };
        };
        ResultListObject: {
            success?: boolean;
            data?: unknown[];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 重新提交失败视频任务请求 */
        ResubmitAiJobRequest: {
            /**
             * Format: int64
             * @description 失败任务主键 user_ai_job.id
             * @example 78
             */
            id: number;
            /**
             * @description 用户重新选择的内部模型 ID；前端通常从 creation-option 读取，服务端会按当前路由配置校验是否仍可提交
             * @example sd2f
             * @enum {string}
             */
            internalModelId: ResubmitAiJobRequestInternalModelId;
        };
        ResultUploadVideoResponse: {
            success?: boolean;
            data?: components["schemas"]["UploadVideoResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 上传视频结果 */
        UploadVideoResponse: {
            /**
             * Format: int64
             * @description 用户视频资产 ID
             * @example 123
             */
            assetId: number;
            /**
             * @description 视频 CDN 地址
             * @example https://resource.kaloclip.com/resources/1/upload/VIDxxx.mp4
             */
            videoUrl: string;
            /**
             * @description 存储文件名
             * @example VIDabc123.mp4
             */
            fileName: string;
            /**
             * Format: int64
             * @description 文件大小，单位字节
             * @example 1048576
             */
            fileSize: number;
            /**
             * Format: int32
             * @description 视频时长，单位秒
             * @example 60
             */
            duration: number;
            /**
             * @description 封面图 CDN 地址，封面提取成功时有值，失败时为 null
             * @example https://resource.kaloclip.com/resources/1/upload/cover/VIDxxx.jpg
             */
            coverImageUrl?: string;
        };
        /** @description 单张图片 URL 导入项 */
        ImageItem: {
            /**
             * @description 图片 URL，须为 https://img.kalocdn.com 域名
             * @example https://img.kalocdn.com/xxx/yyy.png
             */
            url: string;
            /**
             * @description 图片描述，可选；若传入则回写到 assetDescription
             * @example white shoes on studio background
             */
            description?: string;
        };
        /** @description URL 对象数组；每项 URL 均须为 https://img.kalocdn.com 域名 */
        UploadImageByUrlRequest: {
            images: components["schemas"]["ImageItem"][];
        };
        ResultListUploadImageByUrlItemResponse: {
            success?: boolean;
            data?: components["schemas"]["UploadImageByUrlItemResponse"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 上传单张图片结果，assetId 非 null 表示成功，null 表示失败 */
        UploadImageByUrlItemResponse: {
            /**
             * Format: int64
             * @description 用户资产 ID，视频创作时需携带；null 表示本张上传失败
             * @example 1
             */
            assetId?: number;
            /**
             * @description 图片 CDN 地址，可直接用于视频创作 imageUrl
             * @example https://resource.kalocdn.com/user/123/xxx.png
             */
            imageUrl?: string;
            /** @description 图片描述 */
            description?: string;
            success?: boolean;
        };
        /** @description 翻译请求，包含待翻译文本和目标语言代码 */
        TranslateRequest: {
            /**
             * @description 待翻译文本
             * @example Hello world
             */
            text?: string;
            /**
             * @description 目标语言代码
             * @example zh-CN
             */
            to?: string;
        };
        /** @description 登录响应 */
        LoginResponse: {
            /**
             * @description 访问令牌（Access Token）
             * @example eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiI3bGhRZTExcTIwVCIsImVtYWlsIjoiNDY5NjQ4ODE5QHFxLmNvbSIsImlhdCI6MTc2ODQ3MDExMCwiZXhwIjoxNzY5MDc0OTEwfQ.sObhFTjImGDKdFxIOJtAxRQhGbAW7SUBT4Q19dnuBhM
             */
            accessToken?: string;
            /**
             * Format: int32
             * @description 访问令牌过期时间（秒）
             * @example 604800
             */
            expiresIn?: number;
            /** @description 用户信息 */
            user?: components["schemas"]["UserInfo"];
        };
        ResultLoginResponse: {
            success?: boolean;
            data?: components["schemas"]["LoginResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户信息 */
        UserInfo: {
            /**
             * @description 用户ID（混淆后的）
             * @example 7lhQe11q20T
             */
            uid?: string;
            /**
             * @description 用户邮箱
             * @example 469648819@qq.com
             */
            email?: string;
            /**
             * @description 用户名字
             * @example John
             */
            firstName?: string;
            /**
             * @description 用户姓氏
             * @example Doe
             */
            lastName?: string;
            /**
             * @description 用户头像URL
             * @example https://example.com/avatar.jpg
             */
            avatarUrl?: string;
        };
        /** @description 问题上报请求；有退积分额度时可能触发退积分并占用月度次数，否则仅留痕 */
        IssueReportSubmitRequest: {
            /**
             * @description 报告的任务类型
             * @example VIDEO_CREATION
             * @enum {string}
             */
            jobType: IssueReportSubmitRequestJobType;
            /**
             * Format: int64
             * @description 资产 ID（clip_user_asset.id）
             * @example 1234567890
             */
            assetId: number;
            /**
             * @description 反馈详情 JSON 对象
             * @example {
             *       "issueTypes": [
             *         "video_quality",
             *         "wrong_content"
             *       ],
             *       "otherDescription": "视频画面模糊"
             *     }
             */
            feedback: {
                [key: string]: unknown;
            };
        };
        /** @description 商品链接解析请求 */
        ProductInfoByLinkRequest: {
            /**
             * @description 商品链接
             * @example https://www.kalodata.com/product/detail?id=123&region=US
             */
            url: string;
        };
        /** @description 单张图片合规检测结果 */
        ImageComplianceCheckItemResponse: {
            /**
             * Format: int64
             * @description 图片对应的 assetId
             * @example 1
             */
            assetId?: number;
            /**
             * @description 图片 CDN 地址
             * @example https://resource.kalocdn.com/user/1/xxx.png
             */
            imageUrl?: string;
            /**
             * @description 是否合规
             * @example true
             */
            success?: boolean;
            /**
             * @description 图片描述（仅合规图片有值）
             * @example 商品正面展示图
             */
            description?: string;
        };
        /** @description 商品链接解析信息响应 */
        ProductInfoByLinkResponse: {
            /**
             * @description 用户输入的商品链接来源
             * @example AMAZON
             * @enum {string}
             */
            linkSource?: ProductInfoByLinkResponseLinkSource;
            /** @description 解析出的商品信息 */
            product?: components["schemas"]["SearchTiktokProductResult"];
            /** @description 商品图片信息列表，包含图片 URL、检测状态与描述 */
            images?: components["schemas"]["ImageComplianceCheckItemResponse"][];
        };
        ResultProductInfoByLinkResponse: {
            success?: boolean;
            data?: components["schemas"]["ProductInfoByLinkResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description TikTok商品搜索结果 */
        SearchTiktokProductResult: {
            /**
             * @description 商品ID
             * @example 1730502815821107300
             */
            id?: string;
            /**
             * @description 国家代码
             * @example US
             */
            country?: string;
            /**
             * @description 商品标题
             * @example 无线蓝牙耳机
             */
            productTitle?: string;
            /**
             * @description 商品封面图URL
             * @example https://img.kalocdn.com/tiktok.product/1730502815821107300/cover.png
             */
            coverImageUrl?: string;
            /**
             * @description 一级类目ID
             * @example 100
             */
            priCateId?: string | null;
            /**
             * @description 二级类目ID
             * @example 200
             */
            secCateId?: string | null;
            /**
             * @description 三级类目ID
             * @example 300
             */
            terCateId?: string | null;
            /**
             * @description 一级类目名称
             * @example 电子产品
             */
            priCateName?: string | null;
            /**
             * @description 二级类目名称
             * @example 音频设备
             */
            secCateName?: string | null;
            /**
             * @description 三级类目名称
             * @example 耳机
             */
            terCateName?: string | null;
            /**
             * @description 商品最小售价
             * @example 150.5
             */
            minRealPrice?: string;
            /**
             * @description 商品最大售价
             * @example 299.9
             */
            maxRealPrice?: string;
        };
        /** @description 商品 ID 解析请求 */
        ProductInfoByIdRequest: {
            /**
             * @description 商品 ID
             * @example 1731997246433955867
             */
            id: string;
            /**
             * @description 国家 code，可选
             * @example US
             */
            country?: string;
        };
        /** @description 卖点推测请求，包含封面图 URI 与商品名称 */
        InferSellingPointRequest: {
            /**
             * @description 封面图链接（已上传资源的 URI）
             * @example temporary/123/IMGxxx.jpg
             */
            imageUrl?: string;
            /**
             * @description 商品名称
             * @example skincare
             */
            title?: string;
            /**
             * @description 商品类目；前端传入时会一并用于 AI 推断
             * @example Beauty>Skin Care
             */
            category?: string;
        };
        ProductSellingPoint: {
            keyWord?: string;
            keyWordZh?: string;
            regionText?: string;
        };
        ProductSellingPointsResult: {
            category?: string;
            sellingPoints?: components["schemas"]["ProductSellingPoint"][];
        };
        ResultProductSellingPointsResult: {
            success?: boolean;
            data?: components["schemas"]["ProductSellingPointsResult"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 图片检测并增加描述请求（含商品元数据） */
        ImageCheckAndDescribeRequest: {
            /**
             * @description 商品标题
             * @example Women's Summer Dress
             */
            title: string;
            /**
             * @description 商品类目
             * @example Clothing>Women>Dresses
             */
            category: string;
            /** @description 图片 URL 列表，1~6 个 */
            imageUrls: string[];
        };
        ResultListImageComplianceCheckItemResponse: {
            success?: boolean;
            data?: components["schemas"]["ImageComplianceCheckItemResponse"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 商品详情请求 */
        ProductDetailRequest: {
            /**
             * @description 商品id
             * @example 1731997246433955867
             */
            id: string;
            /**
             * @description 国家
             * @example US
             */
            country: string;
        };
        ResultSearchTiktokProductResult: {
            success?: boolean;
            data?: components["schemas"]["SearchTiktokProductResult"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 商品属性生成请求，包含商品ID */
        GenerateWithIdRequest: {
            /**
             * @description id
             * @example 123456
             */
            id: string;
            /**
             * @description 国家Code
             * @example US
             */
            country?: string;
            /**
             * @description 是否异步处理
             * @example false
             */
            async?: boolean;
        };
        ResultObject: {
            success?: boolean;
            data?: unknown;
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultLong: {
            success?: boolean;
            /** Format: int64 */
            data?: number;
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description Open API 商品链接解析请求 */
        OpenApiProductResolveRequest: {
            /**
             * @description TikTok 或 Kalodata 商品链接（支持 TikTok 商品页、TikTok 短链、Kalodata 商品详情页）
             * @example https://shop.tiktok.com/view/product/1730502815821107300
             */
            productLink: string;
        };
        /** @description Open API 商品链接解析响应 */
        OpenApiProductResolveResponse: {
            /**
             * @description 商品 ID（从链接解析出来；后续接口的 productId 字段可直接用）
             * @example 1730502815821107300
             */
            productId?: string;
            /**
             * @description 商品归属国家代码（从链接或后端推断）
             * @example US
             */
            country?: string;
            /**
             * @description 链接里解析到的语言代码；无则为 null
             * @example en
             */
            language?: string | null;
            /**
             * @description 商品标题；直接作为 /scripts 或 /videos 的 productTitle
             * @example Wireless Bluetooth Earbuds
             */
            productTitle?: string;
            /**
             * @description 类目名称，按一/二/三级顺序；作为 /scripts 的 categoryNames
             * @example [
             *       "Electronics",
             *       "Audio",
             *       "Earphones"
             *     ]
             */
            categoryNames?: string[];
            /**
             * @description 卖点短句列表；作为 /scripts 或 /videos 的 sellingPoints。由商品属性分析（可能含 AI 推断）生成；若后端尚未分析则返回空列表，调用方可重试或忽略。
             * @example [
             *       "Active noise cancelling",
             *       "30-hour battery"
             *     ]
             */
            sellingPoints?: string[];
            /** @description 图片列表，已上传到用户资产库；元素为 {@link ImageDescriptionInfo}，可直接用于 /scripts、/videos 的 imageInfos */
            imageInfos?: components["schemas"]["ImageDescriptionInfo"][];
        };
        ResultOpenApiProductResolveResponse: {
            success?: boolean;
            data?: components["schemas"]["OpenApiProductResolveResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description Google OAuth2 登录请求 */
        GoogleIdTokenRequest: {
            /**
             * @description Google ID Token（credential）
             * @example eyJhbGciOiJSUzI1NiIs...
             */
            credential: string;
            /** @description tccode */
            tc?: string;
        };
        /** @description 用户登录请求，根据 loginMethod 填写对应字段 */
        LoginRequest: {
            /**
             * @description 登录方式
             * @example EMAIL_PASSWORD
             * @enum {string}
             */
            loginMethod: LoginRequestLoginMethod;
            /**
             * @description 邮箱
             * @example user@example.com
             */
            email?: string;
            /**
             * @description 密码
             * @example ******
             */
            password?: string;
            /**
             * @description 邮箱验证码
             * @example 123456
             */
            emailCode?: string;
            /**
             * @description 手机验证码
             * @example 123456
             */
            smsCode?: string;
            /**
             * @description 手机号所属国家码
             * @example 86
             */
            phoneCountryCode?: string;
            /**
             * @description 手机号
             * @example 13800138000
             */
            phoneNumber?: string;
            /**
             * @description Google authorization code（用于 Google 登录）
             * @example 4/0AeaYS...
             */
            code?: string;
            /**
             * @description tccode
             * @example tc123
             */
            tc?: string;
            /**
             * @description 场景
             * @default login
             * @example login
             */
            scene: string;
            emailPassword?: string;
        };
        ResultListSearchTiktokProductResult: {
            success?: boolean;
            data?: components["schemas"]["SearchTiktokProductResult"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 关注/取消关注请求 */
        FocusRequest: {
            /**
             * @description 实体ID（如视频ID、用户ID）
             * @example 7583359920158903565
             */
            entityId: string;
            /**
             * @description 分组类型
             * @example video
             */
            groupType: string;
        };
        /** @description 视频脚本生成下载请求，包含请求ID列表、是否翻译等 */
        VideoScriptGenerateDownloadRequest: {
            /**
             * @description 请求ID列表（脚本生成任务的 requestId）
             * @example [
             *       "34037e69d75f4"
             *     ]
             */
            requestIds: string[];
            /**
             * Format: int32
             * @description 激活的脚本索引（用于多脚本时指定下载哪条）
             * @example 0
             */
            activeScript?: number;
            /**
             * @description 是否翻译脚本内容
             * @example false
             */
            translate?: boolean;
        };
        /** @description 视频脚本解析下载请求，包含视频ID、来源、是否翻译等 */
        VideoScriptAnalysisDownloadRequest: {
            /**
             * @description 视频ID
             * @example 7583359920158903565
             */
            id: string;
            /**
             * @description 是否翻译脚本内容
             * @example false
             */
            translate?: boolean;
            /**
             * @description 视频来源
             * @example Kalodata
             * @enum {string}
             */
            videoSource?: VideoScriptAnalysisDownloadRequestVideoSource;
        };
        /** @description 撤销设备请求 */
        InvalidateDeviceRequest: {
            /**
             * @description 设备ID
             * @example a1b2c3d4e5f6789
             */
            deviceId: string;
        };
        /** @description 配置查询请求，每个请求包含一个配置 key */
        ConfigurationRequest: {
            /**
             * @description 配置项 key
             * @example app.version
             */
            key?: string;
        };
        GlobalConfig: unknown;
        ResultMapStringListGlobalConfig: {
            success?: boolean;
            data?: {
                [key: string]: components["schemas"]["GlobalConfig"][];
            };
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 角色资产创建表单请求 */
        CharacterAssetCreateFormRequest: {
            /**
             * @description 角色分类
             * @example MODEL
             * @enum {string}
             */
            category: CharacterAssetCreateFormRequestCategory;
            /**
             * @description 角色名称
             * @example Demo Character
             */
            name: string;
            /**
             * Format: binary
             * @description 角色主图/正视图
             */
            mainImage: string;
            /** @description 角色其他视角图片，最多 3 张 */
            otherImages?: string[];
        };
        /** @description Send captcha request */
        SmsSendCaptchaRequest: {
            /**
             * @description Scene
             * @default login
             * @example login
             */
            scene: string;
            /**
             * @description 人机验证返回的 response 字符串
             * @example token_from_captcha
             */
            response: string;
            /**
             * @description Country code
             * @example 86
             */
            countryCode: string;
            /**
             * @description Phone number
             * @example 13588031592
             */
            phoneNumber: string;
            /**
             * @description Captcha type
             * @example aliyun
             */
            captchaType: string;
        };
        /** @description Email send captcha request */
        EmailSendCaptchaRequest: {
            /**
             * @description Scene
             * @default login
             * @example login
             */
            scene: string;
            /**
             * @description Response token
             * @example token
             */
            response: string;
            /**
             * Format: email
             * @description Email address
             * @example 469648819@qq.com
             */
            email: string;
        };
        /** @description 资源下载记录请求 */
        AssetDownloadRecordRequest: {
            /**
             * Format: int64
             * @description 资产 ID（clip_user_asset.id）
             * @example 1234567890
             */
            assetId: number;
        };
        /** @description 管理员批量补偿新用户试用积分请求 */
        GrantUserTrialCreditBatchRequest: {
            /**
             * @description 需要补偿的用户 ID 列表
             * @example [
             *       123,
             *       456,
             *       789
             *     ]
             */
            userIds: number[];
        };
        /** @description 清理用户限流请求 */
        ClearRateLimitRequest: {
            /**
             * Format: int64
             * @description 用户ID
             * @example 123
             */
            userId: number;
        };
        ResultBoolean: {
            success?: boolean;
            data?: boolean;
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultVideoUrlResponse: {
            success?: boolean;
            data?: components["schemas"]["VideoUrlResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频URL响应 */
        VideoUrlResponse: {
            /**
             * @description 视频CDN URL
             * @example https://live.kalocdn.com/video/123456.mp4
             */
            url?: string;
            /**
             * Format: int32
             * @description 视频处理状态：1=已下载，0=下载失败，2=下载中
             * @example 1
             * @enum {integer}
             */
            status?: VideoUrlResponseStatus;
        };
        AudioScript: {
            /** Format: int32 */
            start_time?: number;
            /** Format: int32 */
            end_time?: number;
            script?: string;
            translate_script?: string;
        };
        ResultVideoScriptGeneratedResult: {
            success?: boolean;
            data?: components["schemas"]["VideoScriptGeneratedResult"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频脚本生成结果 */
        VideoScriptGeneratedResult: {
            /** @description 脚本方案1 */
            script1?: components["schemas"]["VideoScriptMulationDO"][];
            /** @description 脚本方案2 */
            script2?: components["schemas"]["VideoScriptMulationDO"][];
        };
        /** @description 视频脚本变体 */
        VideoScriptMulationDO: {
            /**
             * @description 场景描述
             * @example 产品展示场景
             */
            scene?: string;
            /**
             * @description 场景描述翻译
             * @example Product display scene
             */
            translate_scene?: string;
            /**
             * @description 视觉描述
             * @example 特写镜头展示产品细节
             */
            visual_description?: string;
            /**
             * @description 视觉描述翻译
             * @example Close-up shot showing product details
             */
            translate_visual_description?: string;
            /** @description 音频脚本列表 */
            audio_script?: components["schemas"]["AudioScript"][];
        };
        ResultVideoScriptResult: {
            success?: boolean;
            data?: components["schemas"]["VideoScriptResult"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ScriptDetail: {
            scene?: string;
            translate_scene?: string;
            /** Format: int32 */
            start_time?: number;
            /** Format: int32 */
            end_time?: number;
            shot_scale?: string;
            translate_shot_scale?: string;
            visual_description?: string;
            translate_visual_description?: string;
            audio_script?: components["schemas"]["AudioScript"][];
        };
        VideoScriptResult: {
            gender?: string;
            translate_gender?: string;
            language?: string;
            language_code?: string;
            translate_language?: string;
            camera_work?: string;
            translate_camera_work?: string;
            key_to_success?: string;
            key_to_success_list?: string[];
            translate_key_to_success?: string;
            translate_key_to_success_list?: string[];
            video_scripts?: components["schemas"]["ScriptDetail"][];
        };
        /** @description 作业输入上下文基类型（按 jobType 对应具体子类型） */
        AiJobInputResponse: {
            /**
             * Format: int32
             * @description 视频时长（秒）
             * @example 15
             */
            duration?: number;
            /** @enum {string} */
            resolution?: AiJobInputResponseResolution;
            /**
             * @description 稳定内部模型 ID
             * @example v31
             */
            internalModelId?: string;
            /** Format: int32 */
            quantity?: number;
            productTitle?: string;
            /** @enum {string} */
            aspectRatio?: AiJobInputResponseAspectRatio;
            firstProductImageUrl?: string;
        } & (components["schemas"]["VideoCreationJobInputResponse"] | components["schemas"]["VideoRemakeJobInputResponse"]);
        AiJobOutput: unknown;
        ReferenceScriptOutputContext: components["schemas"]["AiJobOutput"] & {
            script?: string;
        };
        ResultUserAiJobDetailResponse: {
            success?: boolean;
            data?: components["schemas"]["UserAiJobDetailResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description AI 作业详情 */
        UserAiJobDetailResponse: {
            /**
             * Format: int64
             * @description 作业主键（user_ai_job.id）
             * @example 12345
             */
            id?: number;
            /**
             * @description 任务类型枚举名
             * @example VIDEO_CREATION
             */
            jobType?: string;
            /**
             * @description 资源 ID（任务唯一标识）
             * @example vc_abc123
             */
            resourceId?: string;
            /**
             * @description 对外状态
             * @example processing
             */
            state?: string;
            /**
             * Format: int32
             * @description 重试次数
             * @example 1
             */
            retryCount?: number;
            /**
             * @description 失败原因
             * @example supplier timeout
             */
            errorMessage?: string;
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1738745600000
             */
            gmtCreated?: number;
            /**
             * Format: int64
             * @description 更新时间戳
             * @example 1738745601000
             */
            gmtUpdated?: number;
            /**
             * Format: int32
             * @description 当前排队位置，仅非终态时有值
             * @example 3
             */
            queuePosition?: number;
            /**
             * Format: int64
             * @description 预估完成时间戳（毫秒），仅非终态时有值
             * @example 1738745840000
             */
            estimatedCompletionTime?: number;
            /** @description 输入上下文（由 inputContext JSON 反序列化）。按 jobType 分发：VIDEO_CREATION → VideoCreationJobInputResponse；VIDEO_REMAKE → VideoRemakeJobInputResponse */
            input?: components["schemas"]["AiJobInputResponse"];
            /** @description 输出上下文（由 outputContext JSON 反序列化）。按 jobType 分发：VIDEO_CREATION/VIDEO_EDITING → VideoCreationOutputContext；VIDEO_REMAKE → VideoRemakeOutputContext；REFERENCE_SCRIPT_GENERATE → ReferenceScriptOutputContext (script) */
            output?: components["schemas"]["VideoCreationOutputContext"] | components["schemas"]["VideoRemakeOutputContext"] | components["schemas"]["ReferenceScriptOutputContext"];
        };
        /** @description 视频创作任务输入 */
        VideoCreationJobInputResponse: {
            /** @description 商品图片信息 */
            imageInfos?: components["schemas"]["ImageDescriptionInfo"][];
            /**
             * @description 用户提交前的原始脚本
             * @example This is a video about a cute cat playing with a ball.
             */
            originScript?: string;
            /**
             * @description 用户最终传入的脚本
             * @example This is a video about a cute cat playing with a ball.
             */
            userModifiedScript?: string;
            /**
             * @description 产品标题
             * @example Wireless Earbuds
             */
            productTitle?: string;
            /**
             * @description 产品ID
             * @example 123456
             */
            productId?: string;
            /**
             * @description 商品国家代码
             * @example US
             */
            country?: string;
            /**
             * @description 视频比例
             * @example RATIO_9_16
             * @enum {string}
             */
            aspectRatio?: VideoCreationJobInputResponseAspectRatio;
            /**
             * Format: int32
             * @description 视频时长（秒）
             * @example 15
             */
            duration?: number;
            /**
             * Format: int32
             * @description 生成数量
             * @example 1
             */
            quantity?: number;
            /**
             * @description 视频清晰度
             * @example 720P
             * @enum {string}
             */
            resolution?: VideoCreationJobInputResponseResolution;
            /**
             * @description 稳定内部模型 ID
             * @example v31
             */
            internalModelId?: string;
            /**
             * @description 模型展示编码（由 internalModelId 映射）
             * @example VEMO
             */
            modelCode?: string;
            /** @description 商品分类名称列表 */
            categoryNames?: string[];
            /** @description 商品卖点列表 */
            sellingPoints?: string[];
            /** @description 创作描述 */
            creationDescription?: string;
            /**
             * @description 销售国家
             * @example United States
             */
            sellingCountry?: string;
            /**
             * @description 视频语言
             * @example en
             */
            language?: string;
            firstProductImageUrl?: string;
        };
        VideoCreationOutputContext: components["schemas"]["AiJobOutput"] & {
            videoUrl?: string;
            coverImageUrl?: string;
            enhanceVideoUrl?: string;
            /** Format: int64 */
            userAssetId?: number;
        };
        /** @description 视频复刻任务输入 */
        VideoRemakeJobInputResponse: {
            /** @description 商品图片信息 */
            imageInfos?: components["schemas"]["ImageDescriptionInfo"][];
            /**
             * Format: int64
             * @description 角色资产 ID，对应 CharacterAssetDO.id
             * @example 3001
             */
            characterAssetId?: number;
            /**
             * @description 产品标题
             * @example Wireless Earbuds
             */
            productTitle?: string;
            /**
             * @description 产品ID
             * @example 123456
             */
            productId?: string;
            /**
             * @description 商品归属国家参数代码
             * @example US
             */
            productCountry?: string;
            /**
             * @description 视频比例
             * @example RATIO_9_16
             * @enum {string}
             */
            aspectRatio?: VideoRemakeJobInputResponseAspectRatio;
            /**
             * Format: int32
             * @description 视频时长（秒）
             * @example 15
             */
            duration?: number;
            /**
             * Format: int32
             * @description 生成数量
             * @example 1
             */
            quantity?: number;
            /**
             * @description 视频清晰度
             * @example 720P
             * @enum {string}
             */
            resolution?: VideoRemakeJobInputResponseResolution;
            /**
             * @description 稳定内部模型 ID
             * @example v31
             */
            internalModelId?: string;
            /**
             * @description 模型展示编码（由 internalModelId 映射）
             * @example Stellar 1.1
             */
            modelCode?: string;
            /** @description 商品分类名称列表 */
            categoryNames?: string[];
            /** @description 商品卖点列表 */
            sellingPoints?: string[];
            /**
             * @description 用户输入的提示词
             * @example Keep the same pacing and replace the product in every shot.
             */
            userInputPrompt?: string;
            /**
             * @description 销售国家
             * @example United States
             */
            sellingCountry?: string;
            /**
             * @description 视频语言
             * @example en
             */
            language?: string;
            /**
             * @description 参考视频 URL（上传场景由 videoAssetId 解析；外链场景为平台可下载 URL）
             * @example https://resource.kaloclip.com/resources/1/upload/VIDabc.mp4
             */
            videoUrl?: string;
            /**
             * Format: int64
             * @description 参考视频用户资产 ID
             * @example 88
             */
            videoAssetId?: number;
            /**
             * @description 参考视频来源平台，如 TikTok/Kalodata/YouTube/Instagram/Kaloclip
             * @example Kaloclip
             * @enum {string}
             */
            videoSource?: VideoRemakeJobInputResponseVideoSource;
            /**
             * @description 参考视频平台侧 ID
             * @example 7312345678901234567
             */
            videoId?: string;
            firstProductImageUrl?: string;
        };
        VideoRemakeOutputContext: components["schemas"]["AiJobOutput"] & {
            videoUrl?: string;
            coverImageUrl?: string;
            enhanceVideoUrl?: string;
            /** Format: int64 */
            userAssetId?: number;
        };
        ResultVideoDetailResponse: {
            success?: boolean;
            data?: components["schemas"]["VideoDetailResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 视频详情响应 */
        VideoDetailResponse: {
            /**
             * @description 视频ID
             * @example 7123456789012345678
             */
            id?: string;
            /**
             * @description 视频封面图URL
             * @example https://img.kalocdn.com/tiktok.video/xxx/cover.jpg
             */
            coverImageUrl?: string;
            /**
             * @description 视频描述
             * @example 这是一个精彩的视频
             */
            description?: string;
            /**
             * Format: int32
             * @description 视频时长(s)
             * @example 60
             */
            duration?: number;
            /**
             * @description 视频来源
             * @example 60
             */
            videoSource?: string;
            /**
             * @description 是否为带货视频
             * @example false
             */
            hasProduct?: boolean;
            /**
             * @description 第一个带货商品 id
             * @example 1729606769780232427
             */
            firstProductId?: string;
        };
        /** @description 作业上下文基类型（按 jobType 对应具体子类型） */
        BaseResponseContext: unknown;
        ResultListUserAssetItemResponse: {
            success?: boolean;
            data?: components["schemas"]["UserAssetItemResponse"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户 AI 作业列表项 */
        UserAiJobItemResponse: {
            /**
             * Format: int64
             * @description 作业主键（user_ai_job.id）
             * @example 12345
             */
            jobId?: number;
            /**
             * @description 资源 ID（task 唯一标识，前端轮询 /video/creation/status 等时使用）
             * @example vc_abc123
             */
            resourceId?: string;
            /**
             * @description 任务类型枚举名
             * @example VIDEO_CREATION
             * @enum {string}
             */
            jobType?: UserAiJobItemResponseJobType;
            /**
             * @description 任务类型展示文案
             * @example Video Creation
             */
            copywriting?: string;
            /**
             * @description 对外展示状态（前端按 key 展示文案与样式）
             * @example processing
             * @enum {string}
             */
            status?: UserAiJobItemResponseStatus;
            /**
             * @description 稳定内部模型 ID（仅视频生成类任务有值）
             * @example sd2f
             */
            internalModelId?: string;
            /** @description 作业上下文（按 jobType 为不同结构：VIDEO_CREATION/VIDEO_REMAKE 见对应 Context 子类型），未完成或无数据时为 null */
            context?: components["schemas"]["BaseResponseContext"];
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1738745600000
             */
            gmtCreated?: number;
            /**
             * @description 失败原因（仅失败时有值）
             * @example supplier timeout
             */
            errorMessage?: string;
        };
        /** @description 用户资产库列表项 */
        UserAssetItemResponse: {
            /**
             * Format: int64
             * @description 资产 ID
             * @example 1
             */
            id?: number;
            /**
             * @description 资产类型
             * @example IMG
             * @enum {string}
             */
            assetType?: UserAssetItemResponseAssetType;
            /**
             * @description 资产来源
             * @example USER
             * @enum {string}
             */
            assetSource?: UserAssetItemResponseAssetSource;
            /**
             * @description 文件名（含扩展名）
             * @example photo.png
             */
            fileName?: string;
            /**
             * Format: int64
             * @description 文件大小（字节）
             * @example 102400
             */
            fileSize?: number;
            /**
             * @description 访问 URL（CDN）
             * @example https://resource.kaloclip.com/user/123/IMGxxx.png
             */
            url?: string;
            /** @description 资产描述（可选） */
            assetDescription?: string;
            /**
             * Format: int32
             * @description 状态：1-正常, 0-回收站, -1-已删除
             * @example 1
             */
            state?: number;
            /**
             * Format: int64
             * @description job创建时间戳
             * @example 1738745600000
             */
            gmtCreated?: number;
            /** @description 关联的 AI 作业信息（复用 UserAiJobItemResponse），仅当 jobId 不为空时由服务端填充 */
            jobItem?: components["schemas"]["UserAiJobItemResponse"];
            /**
             * @description 视频发布状态：取该 asset 最新一条发布记录，且仅在 SUCCESS/PENDING_PUBLISH 时返回
             * @example SUCCESS
             * @enum {string}
             */
            videoPublishStatus?: UserAssetItemResponseVideoPublishStatus;
            /**
             * Format: int64
             * @description 视频发布时间戳
             * @example 1738745600000
             */
            videoPublishTime?: number;
            /**
             * Format: int64
             * @description 预计完成时间戳（创建时间 + 12 分钟）
             * @example 1738746320000
             */
            gmtEstimatedCompleted?: number;
        };
        ResultUserPublishResultResponse: {
            success?: boolean;
            data?: components["schemas"]["UserPublishResultResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 预检质量问题条目（TikTok precheck_task.issues 透传） */
        UserPublishIssueItem: {
            /**
             * @description 风险类型
             * @example Pirated Content
             */
            risk?: string;
            /**
             * @description 处理建议
             * @example Your video may include unoriginal content...
             */
            suggestions?: string;
        };
        /** @description 发布视频的数据表现（汇总指标） */
        UserPublishPerformanceResponse: {
            /**
             * @description 点击率
             * @example 0.15
             */
            clickThroughRate?: string;
            /**
             * Format: int64
             * @description 订单数
             * @example 7
             */
            orderCount?: number;
            /**
             * Format: int64
             * @description 售出件数
             * @example 10
             */
            itemSoldCount?: number;
            /**
             * @description GMV 金额（多币种不一致时为 null）
             * @example 30.75
             */
            gmvAmount?: string;
            /**
             * @description GMV 币种
             * @example USD
             */
            gmvCurrency?: string;
        };
        /** @description 视频发布结果（用于轮询） */
        UserPublishResultResponse: {
            /**
             * Format: int64
             * @description 发布记录 id
             * @example 3001
             */
            id: number;
            /**
             * Format: int64
             * @description 关联账号 id
             * @example 1001
             */
            linkId: number;
            /**
             * Format: int64
             * @description 资产 id
             * @example 2001
             */
            assetId: number;
            /**
             * @description 平台
             * @example TIKTOK
             * @enum {string}
             */
            platform: UserPublishResultResponsePlatform;
            /**
             * @description 发布模式
             * @example NOW
             * @enum {string}
             */
            publishMode: UserPublishResultResponsePublishMode;
            /**
             * @description 发布状态
             * @example PUBLISHING
             * @enum {string}
             */
            status: UserPublishResultResponseStatus;
            /**
             * @description 是否终态（SUCCESS / FAIL / PRE_CHECK_FAIL）
             * @example false
             */
            terminal: boolean;
            /**
             * @description 是否需要用户二次确认（PRE_CHECK_SUCCESS 且存在质量 issues）
             * @example false
             */
            needConfirm: boolean;
            /** @description 预检质量问题列表（可能在 PRE_CHECK_SUCCESS / PRE_CHECK_FAIL 时返回） */
            issues?: components["schemas"]["UserPublishIssueItem"][];
            /**
             * @description 平台错误码，格式 {PLATFORM}-{code}（FAIL / PRE_CHECK_FAIL 时返回，非平台接口层异常为 null）
             * @example TIKTOK-170001019
             */
            failCode?: string;
            /**
             * @description 失败原因（FAIL / PRE_CHECK_FAIL 时返回）
             * @example The product doesn't exist.
             */
            failReason?: string;
            /**
             * Format: int64
             * @description 计划发布时间（毫秒时间戳，始终有值）
             * @example 1745712000000
             */
            publishTime?: number;
            /**
             * Format: int64
             * @description 实际发布时间，发布成功后有值（毫秒时间戳）
             * @example 1745712000000
             */
            postTime?: number;
            /**
             * @description 提交时是否要求预校验（仅显式为 true 时为 true，否则 false）
             * @example false
             */
            needPrecheck?: boolean;
            /**
             * @description 商品标题
             * @example Wireless Earbuds
             */
            productTitle?: string;
            /**
             * @description 商品图片 URL
             * @example https://resource.kaloclip.com/publish/product/TIKTOK/1001/IMGabc.png
             */
            productImage?: string;
            /**
             * @description 视频封面图 URL
             * @example https://resource.kaloclip.com/resources/100/generate/vc_xxx/cover.jpg
             */
            assetCoverImageUrl?: string;
            /**
             * @description 账号名称
             * @example Kaloclip Official
             */
            accountName?: string;
            /**
             * @description 账号头像 URL
             * @example https://resource.kaloclip.com/avatar/TIKTOK/abc/IMGxxx.png
             */
            accountImage?: string;
            /** @description 视频的销售表现 */
            performance?: components["schemas"]["UserPublishPerformanceResponse"];
        };
        PageResultUserPublishResultResponse: {
            data?: components["schemas"]["UserPublishResultResponse"][];
            /** Format: int64 */
            pageNo?: number;
            /** Format: int64 */
            pageSize?: number;
            /** Format: int64 */
            total?: number;
        };
        ResultPageResultUserPublishResultResponse: {
            success?: boolean;
            data?: components["schemas"]["PageResultUserPublishResultResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultUserProfileResponse: {
            success?: boolean;
            data?: components["schemas"]["UserProfileResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        UserProfileResponse: {
            uid?: string;
            username?: string;
            firstName?: string;
            lastName?: string;
            phoneCountryCode?: string;
            phoneNumber?: string;
            password?: string;
            language?: string;
            /** Format: int32 */
            verified?: number;
            /** Format: int32 */
            phoneVerified?: number;
            /** Format: int32 */
            tiktokVerified?: number;
            email?: string;
            /** Format: int32 */
            emailVerified?: number;
            avatarUrl?: string;
            passwordExist?: boolean;
        };
        /** @description 媒体协议单条内容 */
        MediaAgreementItemResponse: {
            /**
             * @description 条款正文
             * @example 用户同意授权平台在合法范围内使用其上传的肖像与媒体内容。
             */
            content?: string;
        };
        /** @description 媒体协议状态响应 */
        MediaAgreementStatusResponse: {
            /**
             * @description 用户是否已同意当前版本协议
             * @example true
             */
            agreed?: boolean;
            /**
             * Format: int32
             * @description 当前协议版本号（int），同意接口需携带
             * @example 1
             */
            currentVersion?: number;
            /**
             * Format: int32
             * @description 用户已同意的版本号（如未同意则为 null）
             * @example 1
             */
            agreedVersion?: number;
            /**
             * Format: int64
             * @description 用户同意协议的时间戳（毫秒，如未同意则为 null）
             * @example 1700000000000
             */
            agreedAt?: number;
            /** @description 协议条款列表；仅当 agreed=false 时返回，已同意时为空列表 */
            items?: components["schemas"]["MediaAgreementItemResponse"][];
        };
        ResultMediaAgreementStatusResponse: {
            success?: boolean;
            data?: components["schemas"]["MediaAgreementStatusResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultMapStringBoolean: {
            success?: boolean;
            data?: {
                [key: string]: boolean;
            };
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultListUserLinkAccountItemResponse: {
            success?: boolean;
            data?: components["schemas"]["UserLinkAccountItemResponse"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户关联账号列表项 */
        UserLinkAccountItemResponse: {
            /**
             * Format: int64
             * @description 主键
             * @example 1
             */
            id: number;
            /**
             * @description 平台
             * @example TIKTOK
             * @enum {string}
             */
            platform: UserLinkAccountItemResponsePlatform;
            /**
             * @description 平台账号 ID
             * @example open_id_xxx
             */
            accountId?: string;
            /**
             * @description 平台账号用户类型
             * @example CREATOR=创作者  SELLER=卖家
             */
            accountUserType?: string;
            /**
             * @description 平台账号 类型
             * @example TIKTOK_SHOP_OFFICIAL_ACCOUNT=店铺号  TIKTOK_MARKETING_ACCOUNT=营销号 TIKTOK_SHOP_CREATOR=达人号
             */
            accountType?: string;
            /**
             * @description 平台账号 昵称
             * @example dazzlin_beauty
             */
            accountName?: string;
            /**
             * @description 平台账号 头像
             * @example https://xxx
             */
            accountImage?: string;
            /**
             * @description 地区
             * @example US
             */
            region?: string;
            /**
             * Format: int64
             * @description 授权过期时间（毫秒时间戳）
             * @example 1776839439000
             */
            accessExpireTime?: number;
            /**
             * Format: int64
             * @description 创建时间（毫秒时间戳）
             * @example 1738745600000
             */
            gmtCreated: number;
            /**
             * Format: int64
             * @description 更新时间（毫秒时间戳）
             * @example 1738745600000
             */
            gmtUpdated: number;
            /**
             * @description 账号是否过期
             * @example false
             */
            expired?: boolean;
        };
        PageResultUserProductResponse: {
            data?: components["schemas"]["UserProductResponse"][];
            /** Format: int64 */
            pageNo?: number;
            /** Format: int64 */
            pageSize?: number;
            /** Format: int64 */
            total?: number;
        };
        ResultPageResultUserProductResponse: {
            success?: boolean;
            data?: components["schemas"]["PageResultUserProductResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        PageResultUserAssetItemResponse: {
            data?: components["schemas"]["UserAssetItemResponse"][];
            /** Format: int64 */
            pageNo?: number;
            /** Format: int64 */
            pageSize?: number;
            /** Format: int64 */
            total?: number;
        };
        ResultPageResultUserAssetItemResponse: {
            success?: boolean;
            data?: components["schemas"]["PageResultUserAssetItemResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 图片专属信息（预留） */
        ImgExtra: unknown;
        PageResultUserAssetItemV2Response: {
            data?: components["schemas"]["UserAssetItemV2Response"][];
            /** Format: int64 */
            pageNo?: number;
            /** Format: int64 */
            pageSize?: number;
            /** Format: int64 */
            total?: number;
        };
        ResultPageResultUserAssetItemV2Response: {
            success?: boolean;
            data?: components["schemas"]["PageResultUserAssetItemV2Response"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户资产库列表项 V2 */
        UserAssetItemV2Response: {
            /**
             * Format: int64
             * @description 资产 ID
             * @example 1
             */
            id: number;
            /**
             * @description 资产类型
             * @example VID
             * @enum {string}
             */
            assetType: UserAssetItemV2ResponseAssetType;
            /**
             * @description 资产来源
             * @example USER
             * @enum {string}
             */
            assetSource: UserAssetItemV2ResponseAssetSource;
            /**
             * @description 文件名（含扩展名）
             * @example VIDxxx.mp4
             */
            fileName: string;
            /**
             * Format: int64
             * @description 文件大小（字节）
             * @example 102400
             */
            fileSize: number;
            /**
             * @description 访问 URL（CDN）
             * @example https://resource.kaloclip.com/resources/1/upload/VIDxxx.mp4
             */
            url: string;
            /**
             * @description 封面图 URL。仅 assetType=VID 时有值；USER/EXT 来源取资产 metadata，AI 来源取 job 上下文
             * @example https://resource.kaloclip.com/resources/1/upload/cover/VIDxxx.jpg
             */
            coverImageUrl?: string;
            /** @description 资产描述（可选） */
            assetDescription?: string;
            /**
             * Format: int32
             * @description 状态：1-正常, 0-回收站, -1-已删除
             * @example 1
             */
            state: number;
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1738745600000
             */
            gmtCreated: number;
            /** @description 关联的 AI 作业信息，仅 AI 生成资产且 jobId 不为空时由服务端填充 */
            jobItem?: components["schemas"]["UserAiJobItemResponse"];
            /** @description 图片专属信息，仅 assetType=IMG 时有值，当前预留空结构供后续扩展 */
            imgExtra?: components["schemas"]["ImgExtra"];
            /** @description 视频专属信息，仅 assetType=VID 时有值，其他类型为 null */
            vidExtra?: components["schemas"]["VidExtra"];
            /**
             * Format: int64
             * @description 预计完成时间戳（创建时间 + 15 分钟），仅 jobItem 不为空时有值
             * @example 1738746320000
             */
            gmtEstimatedCompleted?: number;
        };
        /** @description 视频专属信息 */
        VidExtra: {
            /**
             * @description 封面图 CDN 地址，封面已生成时有值
             * @example https://resource.kaloclip.com/resources/1/upload/cover/VIDxxx.jpg
             */
            coverImageUrl?: string;
            /**
             * Format: int32
             * @description 视频时长（秒）
             * @example 60
             */
            duration?: number;
            /**
             * @description 发布状态，取最新一条发布记录，仅在 SUCCESS/PENDING_PUBLISH 时返回
             * @example SUCCESS
             * @enum {string}
             */
            videoPublishStatus?: VidExtraVideoPublishStatus;
            /**
             * Format: int64
             * @description 发布时间戳
             * @example 1738745600000
             */
            videoPublishTime?: number;
        };
        /** @description 商品展示信息 */
        ProductInfo: {
            /**
             * @description 商品标题
             * @example Wireless Earbuds
             */
            productTitle?: string;
            /**
             * @description 商品封面图 URL（来自 job input 第一张商品图）
             * @example https://resource.kaloclip.com/...
             */
            productCoverImageUrl?: string;
        };
        ResultListUserAssetTrashItemResponse: {
            success?: boolean;
            data?: components["schemas"]["UserAssetTrashItemResponse"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 用户资产回收站列表项 V2 */
        UserAssetTrashItemResponse: {
            /**
             * Format: int64
             * @description 资产 ID
             * @example 1
             */
            id: number;
            /**
             * @description 资产类型
             * @example VID
             * @enum {string}
             */
            assetType: UserAssetTrashItemResponseAssetType;
            /**
             * @description 资产来源
             * @example USER
             * @enum {string}
             */
            assetSource: UserAssetTrashItemResponseAssetSource;
            /**
             * @description 文件名（含扩展名）
             * @example VIDxxx.mp4
             */
            fileName: string;
            /**
             * Format: int64
             * @description 文件大小（字节）
             * @example 102400
             */
            fileSize: number;
            /**
             * @description 访问 URL（CDN）
             * @example https://resource.kaloclip.com/resources/1/upload/VIDxxx.mp4
             */
            url: string;
            /**
             * @description 封面图 URL。仅 assetType=VID 时有值；USER/EXT 来源取资产 metadata，AI 来源取 job 上下文
             * @example https://resource.kaloclip.com/resources/1/upload/cover/VIDxxx.jpg
             */
            coverImageUrl?: string;
            /** @description 资产描述（可选） */
            assetDescription?: string;
            /**
             * Format: int32
             * @description 状态：1-正常, 0-回收站, -1-已删除
             * @example 0
             */
            state: number;
            /**
             * Format: int64
             * @description 创建时间戳
             * @example 1738745600000
             */
            gmtCreated: number;
            /** @description AI 任务关联的商品展示信息，仅 AI 视频资产且能解析到输入上下文时返回 */
            productInfo?: components["schemas"]["ProductInfo"];
            /** @description 图片专属信息，仅 assetType=IMG 时有值，当前预留空结构供后续扩展 */
            imgExtra?: components["schemas"]["ImgExtra"];
            /** @description 视频专属信息，仅 assetType=VID 时有值，其他类型为 null */
            vidExtra?: components["schemas"]["VidExtra"];
        };
        ResultTkShopVideoProductResponse: {
            success?: boolean;
            data?: components["schemas"]["TkShopVideoProductResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description TikTok Shop 场景下用户视频关联的商品信息 */
        TkShopVideoProductResponse: {
            /**
             * @description 商品 ID
             * @example 1729592969712207012
             */
            productId: string;
            /**
             * @description 商品标题
             * @example Wireless Earbuds
             */
            productTitle: string;
            /**
             * @description 商品主图 URL
             * @example https://...
             */
            imageUrl?: string;
            /**
             * Format: int32
             * @description 商品销量
             * @example 150000
             */
            salesCount?: number;
        };
        ResultTkShopAccountProductPageResponse: {
            success?: boolean;
            data?: components["schemas"]["TkShopAccountProductPageResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description TikTok Shop 账号可选商品分页列表 */
        TkShopAccountProductPageResponse: {
            /** @description 当前页商品列表 */
            products?: components["schemas"]["TkShopVideoProductResponse"][];
            /**
             * @description 下一页分页标识（为空代表没有下一页）
             * @example b2Zmc2V0PTIw
             */
            nextPageToken?: string;
            /**
             * Format: int32
             * @description 商品总数（可能为空，取决于开放平台返回）
             * @example 120
             */
            totalCount?: number;
        };
        /** @description 退款次数配额响应 */
        RefundQuotaResponse: {
            /**
             * @description 任务类型（AiJobTypeEnum.name）
             * @example VIDEO_CREATION
             * @enum {string}
             */
            jobType?: RefundQuotaResponseJobType;
            /**
             * Format: int32
             * @description 本月剩余退款次数
             * @example 3
             */
            remaining?: number;
            /**
             * Format: int32
             * @description 每月总退款次数
             * @example 3
             */
            total?: number;
        };
        ResultRefundQuotaResponse: {
            success?: boolean;
            data?: components["schemas"]["RefundQuotaResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        CartItemVO: {
            itemId?: string;
            skuId?: string;
            /** Format: int32 */
            quantity?: number;
            title?: string;
        };
        OrderVO: {
            /** Format: int64 */
            id?: number;
            /** Format: int64 */
            gmtCreated?: number;
            /** Format: int64 */
            gmtModified?: number;
            orderId?: string;
            email?: string;
            status?: string;
            checkoutToken?: string;
            items?: components["schemas"]["CartItemVO"][];
            /** Format: int64 */
            kaloUserId?: number;
            deliverStatus?: string;
            buyerNote?: string;
            source?: string;
            type?: string;
            discountCode?: string;
            /** Format: int64 */
            refundAmount?: number;
            /** Format: int64 */
            refundTime?: number;
            /** Format: int64 */
            payTime?: number;
            detail?: string;
            subscriptionId?: string;
        };
        ResultOrderVO: {
            success?: boolean;
            data?: components["schemas"]["OrderVO"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 积分余额响应 */
        CreditBalanceResponse: {
            /**
             * Format: double
             * @description 剩余总积分（本人月度积分 + 本人长期积分 + ）
             * @example 1000
             */
            totalRemain?: number;
            /**
             * Format: double
             * @description 月度积分（会过期的积分）
             * @example 500
             */
            monthlyRemain?: number;
            /**
             * Format: double
             * @description 长期积分（不会过期的积分）
             * @example 500
             */
            permanentRemain?: number;
            /**
             * @description 是否是子账号
             * @example false
             */
            subAccount?: boolean;
            /**
             * Format: double
             * @description 主账号总积分
             * @example 500
             */
            mainTotalRemain?: number;
            /**
             * Format: double
             * @description 主账号长期积分（不会过期的积分）
             * @example 500
             */
            mainPermanentRemain?: number;
            /**
             * Format: double
             * @description 主账号月度积分（不会过期的积分）
             * @example 200
             */
            mainMonthlyRemain?: number;
        };
        ResultCreditBalanceResponse: {
            success?: boolean;
            data?: components["schemas"]["CreditBalanceResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        ResultListSimpleFocusProductResponse: {
            success?: boolean;
            data?: components["schemas"]["SimpleFocusProductResponse"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        SimpleFocusProductResponse: {
            /**
             * @description 商品ID
             * @example 1730502815821107300
             */
            id?: string;
            /**
             * @description 商品标题
             * @example 无线蓝牙耳机
             */
            productTitle?: string;
            /**
             * @description 国家代码
             * @example US
             */
            country?: string;
            /**
             * @description 商品封面图URL
             * @example https://img.kalocdn.com/tiktok.product/1730502815821107300/cover.png
             */
            coverImageUrl?: string;
            /**
             * @description 一级类目名称
             * @example 电子产品
             */
            priCateName?: string | null;
            /**
             * @description 二级类目名称
             * @example 音频设备
             */
            secCateName?: string | null;
            /**
             * @description 三级类目名称
             * @example 耳机
             */
            terCateName?: string | null;
        };
        DeviceInfo: {
            /** Format: int64 */
            uid?: number;
            /** @enum {string} */
            deviceClass?: DeviceInfoDeviceClass;
            deviceName?: string;
            tokenHash?: string;
            refreshTokenHash?: string;
            /** Format: int64 */
            lastUsedAt?: number;
            /** Format: int64 */
            createdAt?: number;
            osName?: string;
            browserName?: string;
        };
        ResultListDeviceInfo: {
            success?: boolean;
            data?: components["schemas"]["DeviceInfo"][];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 积分日志响应 */
        CreditLogResponse: {
            /**
             * @description 积分消耗来源
             * @example Video content insights
             */
            sourceType?: string;
            /**
             * @description 业务代码（Kalodata/Kaloclip）
             * @example kaloclip
             */
            bizCode?: string;
            /**
             * @description 日期时间
             * @example 2025/09/19 12:09:13
             */
            date?: string;
            /**
             * Format: double
             * @description 积分变化量（正数表示增加，负数表示减少）
             * @example -5
             */
            creditsChange?: number;
            /**
             * @description 主账户账号(邮箱 OR 手机号）
             * @example 123***@gmail.com
             */
            mainAccount?: string;
            /**
             * @description 消费者账户
             * @example 123***@gmail.com
             */
            consumerAccount?: string;
        };
        PageResultCreditLogResponse: {
            data?: components["schemas"]["CreditLogResponse"][];
            /** Format: int64 */
            pageNo?: number;
            /** Format: int64 */
            pageSize?: number;
            /** Format: int64 */
            total?: number;
        };
        ResultPageResultCreditLogResponse: {
            success?: boolean;
            data?: components["schemas"]["PageResultCreditLogResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 积分消费状态检查响应 */
        CreditCheckResponse: {
            /**
             * @description 该内容是否已消耗过积分
             * @example false
             */
            used?: boolean;
        };
        ResultCreditCheckResponse: {
            success?: boolean;
            data?: components["schemas"]["CreditCheckResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        PageResultCharacterAssetResponse: {
            data?: components["schemas"]["CharacterAssetResponse"][];
            /** Format: int64 */
            pageNo?: number;
            /** Format: int64 */
            pageSize?: number;
            /** Format: int64 */
            total?: number;
        };
        ResultPageResultCharacterAssetResponse: {
            success?: boolean;
            data?: components["schemas"]["PageResultCharacterAssetResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
        /** @description 资产状态详情 */
        AssetStateResponse: {
            /**
             * Format: int32
             * @description 资产状态码，1-正常, 0-回收站, -1-已删除, -2-已退还
             * @example 1
             */
            code?: number;
            /**
             * @description 资产状态描述
             * @example 正常
             */
            description?: string;
        };
        ResultAssetStateResponse: {
            success?: boolean;
            data?: components["schemas"]["AssetStateResponse"];
            message?: string;
            debug?: unknown;
            cached?: boolean;
            code?: string;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    listMyProducts: {
        parameters: {
            query?: {
                /**
                 * @description 页码，从 1 开始
                 * @example 1
                 */
                pageNo?: number;
                /**
                 * @description 每页数量
                 * @example 20
                 */
                pageSize?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultPageResultUserProductResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    updateProduct: {
        parameters: {
            query: {
                /**
                 * @description 商品主体 ID
                 * @example 3001
                 */
                productId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserProductUpsertRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserProductResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    createProduct: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserProductUpsertRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserProductResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    deleteProduct: {
        parameters: {
            query: {
                /**
                 * @description 商品主体 ID
                 * @example 3001
                 */
                productId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listCharacterAssets: {
        parameters: {
            query?: {
                /**
                 * @description 角色分类
                 * @example MODEL
                 */
                category?: PathsApiCharacterAssetsGetParametersQueryCategory;
                /**
                 * @description 角色名称模糊搜索
                 * @example Demo
                 */
                name?: string;
                /**
                 * @description 页码，从 1 开始
                 * @example 1
                 */
                pageNo?: number;
                /**
                 * @description 每页数量
                 * @example 20
                 */
                pageSize?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultPageResultCharacterAssetResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    renameCharacterAsset: {
        parameters: {
            query: {
                /**
                 * @description 角色资产 ID
                 * @example 3001
                 */
                assetId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["CharacterAssetRenameRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultCharacterAssetResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    createCharacterAsset: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": components["schemas"]["CharacterAssetCreateFormRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultCharacterAssetResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    deleteCharacterAsset: {
        parameters: {
            query: {
                /**
                 * @description 角色资产 ID
                 * @example 3001
                 */
                assetId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    updateVideoCreationOption: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoCreationOptionConfig"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoCreationOptionConfig"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    updateSuppliersPriority: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: components["schemas"]["ModelSupplierConfig"];
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringModelSupplierConfig"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getGenerateVideoScript: {
        parameters: {
            query: {
                /** @description 唯一请求ID，用于标识脚本生成任务 */
                requestId: string;
                /** @description 收藏ID（可选），如果提供则查询收藏对应的脚本 */
                collectionId?: number;
                /**
                 * @description 激活的脚本索引（用于收藏功能）
                 * @example 0
                 */
                activeScript?: number;
                /**
                 * @description 是否翻译脚本内容
                 * @example false
                 */
                translate?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoScriptGeneratedResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    submitAsyncScript: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoScriptGenerateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultAsyncTaskResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getScriptAnalysisResult: {
        parameters: {
            query: {
                /** @description 视频ID */
                id: string;
                /**
                 * @description 是否翻译脚本内容
                 * @example false
                 */
                translate?: boolean;
                /**
                 * @description 视频来源，默认为TikTok
                 * @example TIKTOK
                 */
                videoSource?: PathsApiVideoScriptAnalysisGetParametersQueryVideoSource;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoScriptResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    startScriptAnalysis: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoIdRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultAsyncTaskResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    startVideoRemake: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoRemakeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    videoRemakeCreditConsume: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoRemakeCreditPreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    buildReferencePromotion: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BuildVideoReferenceScriptRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    recreateVideoCreation: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoRecreationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoLinkPreview: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoLinkPreviewRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoLinkPreviewResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    startVideoCreation: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoCreationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    videoCreationCreditConsume: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BaseVideoCreationOptionRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listTrashAssets: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUserAssetItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    moveToTrash: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["IdRequestLong"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    deleteFromTrash: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["IdRequestLong"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    restoreFromTrash: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["IdRequestLong"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    submit: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserPublishSubmitRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserPublishSubmitResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    confirm: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserPublishConfirmRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    cancel: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserPublishCancelRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCurrentUser: {
        parameters: {
            query?: {
                tc?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserProfileResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    modifyProfile: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ModifyUserProfileRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    confirm_1: {
        parameters: {
            query: {
                /** @description One-time seed matching the /cli-login visit */
                seed: string;
            };
            header?: {
                "Sec-Fetch-Site"?: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    modifyAvatar: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * Format: binary
                     * @description 头像图片文件，支持JPEG、PNG、GIF、WebP格式，大小不超过5MB
                     */
                    file: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getMediaAgreement: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMediaAgreementStatusResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    acceptMediaAgreement: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AcceptMediaAgreementRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    unbind: {
        parameters: {
            query: {
                /**
                 * @description 关联账号记录主键
                 * @example 1
                 */
                id: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    queryStatus: {
        parameters: {
            query: {
                /** @description 关键词（实际为keyword字段的值） */
                id: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserCollectionStatusResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    save: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserCollectionRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    queryList: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UserCollectionRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    resubmitAiJobs: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ResubmitAiJobRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadVideo: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "multipart/form-data": {
                    /**
                     * Format: binary
                     * @description mp4/mov/avi 视频文件，最大 100MB，最长 120 秒
                     */
                    video: string;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUploadVideoResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadImagesByUrl: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UploadImageByUrlRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUploadImageByUrlItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadImagesByUrl_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["UploadImageByUrlRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUploadImageByUrlItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadImages: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @description 图片文件列表，最多6张，仅支持 image/jpeg、image/png、image/gif、image/webp */
                    images: string[];
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUploadImageByUrlItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadImages_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @description 图片文件列表，最多6张，仅支持 image/jpeg、image/png、image/gif、image/webp */
                    images: string[];
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUploadImageByUrlItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    translate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["TranslateRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    refreshToken: {
        parameters: {
            query?: never;
            header?: {
                /** @description 当前的 accessToken（可选），格式：Bearer {token} */
                Authorization?: string;
            };
            path?: never;
            cookie: {
                /** @description 刷新令牌，从 httpOnly cookie 中读取 */
                refreshToken: string;
            };
        };
        requestBody?: never;
        responses: {
            /** @description 请求成功。success=true 表示刷新成功，success=false 表示业务逻辑失败（如 refreshToken 被撤销、频率限制等） */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultLoginResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description 认证失败。refreshToken 已过期、格式错误、签名无效或 cookie 不存在 */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    submitReport: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["IssueReportSubmitRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getProductInfoByLink: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProductInfoByLinkRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultProductInfoByLinkResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getProductInfoById: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProductInfoByIdRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultProductInfoByLinkResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    inferProductSellingPoints: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InferSellingPointRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultProductSellingPointsResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    checkAndDescribeImages: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ImageCheckAndDescribeRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListImageComplianceCheckItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getDetail: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ProductDetailRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultSearchTiktokProductResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getProductAttribute: {
        parameters: {
            query: {
                /** @description 商品ID */
                id: string;
                /** @description 属性key（可选），如果提供则只返回该属性的值 */
                attributeKey?: string;
            };
            header: {
                /**
                 * @description 国家Code
                 * @example US
                 */
                country: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    generateProductAttribute: {
        parameters: {
            query?: never;
            header: {
                /**
                 * @description 国家Code
                 * @example US
                 */
                country: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GenerateWithIdRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    startVideoCreation_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoCreationRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultLong"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    videoCreationCreditPreview: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BaseVideoCreationOptionRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    generateReferenceScript: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["BuildVideoReferenceScriptRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultLong"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    resolve: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["OpenApiProductResolveRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultOpenApiProductResolveResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadImages_2: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    images: string[];
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUploadImageByUrlItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    uploadImagesByUrl_2: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": string[];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUploadImageByUrlItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    kalodataLogin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                };
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultLoginResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    googleOAuth2Login: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    googleLogin: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GoogleIdTokenRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultLoginResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    logout: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    login: {
        parameters: {
            query?: {
                /** @description 可选，URL 查询参数 */
                tc?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LoginRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultLoginResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    log: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    [key: string]: unknown;
                }[];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    queryFocusProductListV2: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListSearchTiktokProductResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    focusEntity: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FocusRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    cancelEntity: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["FocusRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    downloadGenerateVideoScript: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoScriptGenerateDownloadRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    downloadVideoScript: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["VideoScriptAnalysisDownloadRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    invalidateDevice: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["InvalidateDeviceRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listConfigurations: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ConfigurationRequest"][];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringListGlobalConfig"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    verificationCaptcha: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["LoginRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    sendSmsCaptcha: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["SmsSendCaptchaRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    sendEmailCaptcha: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["EmailSendCaptchaRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    recordDownload: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["AssetDownloadRecordRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    triggerUserLinkTokenRefresh: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    compensateTrialCredit: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["GrantUserTrialCreditBatchRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    testSlowResponse: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    clearRateLimitForUser: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": components["schemas"]["ClearRateLimitRequest"];
            };
        };
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    triggerUserPublishPoll: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    reloadAllPromptConfigs: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    invalidateUserTokens: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description 用户ID */
                uid: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    checkAssetTrashCleanup: {
        parameters: {
            query: {
                /** @description 资产 ID */
                assetId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_2: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_3: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_4: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_5: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_6: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_7: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_8: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_9: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_10: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_11: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_12: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_13: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_14: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_15: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_16: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    index_17: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_2: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_3: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_4: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_5: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_6: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_7: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_8: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    ssrIndex_9: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    loginPage: {
        parameters: {
            query: {
                /** @description CLI 生成的一次性随机种子 */
                seed: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/html": string;
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoUrl: {
        parameters: {
            query: {
                /** @description 视频ID */
                id: string;
                /**
                 * @description 视频来源，默认为Kalodata
                 * @example Kalodata
                 */
                videoSource?: PathsApiVideoVideoUrlGetParametersQueryVideoSource;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoUrlResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    tryExample: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoLinkPreviewResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoRemakeJobDetail: {
        parameters: {
            query: {
                /**
                 * @description 作业主键 ID（jobId）
                 * @example 78
                 */
                jobId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserAiJobDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getProductInfoOfVideo: {
        parameters: {
            query: {
                /** @description 视频ID */
                videoId: string;
                /** @description 视频来源 */
                videoSource: PathsApiVideoProductInfoGetParametersQueryVideoSource;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultSearchTiktokProductResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    downloadUrl: {
        parameters: {
            query: {
                /** @description 视频ID */
                videoId: string;
                /** @description 视频来源 */
                videoSource: PathsApiVideoDownloadUrlGetParametersQueryVideoSource;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoDetail: {
        parameters: {
            query: {
                /** @description 视频ID */
                id: string;
                /** @description 视频来源 */
                videoSource?: PathsApiVideoDetailGetParametersQueryVideoSource;
                /** @description 国家代码 */
                country?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoCreationJobDetail: {
        parameters: {
            query: {
                /**
                 * @description 作业主键 ID（jobId）
                 * @example 78
                 */
                jobId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserAiJobDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCreateOption: {
        parameters: {
            query?: {
                /** @description 视频语言缩写（LanguageEnum.abbreviation），如 zh、en；当为中文/英文时会隐藏 15 秒下的 sd2f、sd2 */
                videoLanguage?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoCreationOptionConfig"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    result: {
        parameters: {
            query: {
                /**
                 * @description 发布记录 id
                 * @example 3001
                 */
                id: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserPublishResultResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    page: {
        parameters: {
            query?: {
                /**
                 * @description 资产 id，不传则返回当前用户的所有发布记录
                 * @example 200
                 */
                assetId?: number;
                /**
                 * @description 发布状态，多个用英文逗号分割，不传则不过滤
                 * @example SUCCESS
                 */
                statuses?: string;
                /**
                 * @description 发布模式，不传则不过滤
                 * @example SCHEDULE
                 */
                publishMode?: string;
                /**
                 * @description 关联账号 id，不传则不过滤
                 * @example 1001
                 */
                linkId?: number;
                /** @description 页码，从 1 开始 */
                pageNo?: number;
                /** @description 每页条数 */
                pageSize?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultPageResultUserPublishResultResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    publishCheck: {
        parameters: {
            query: {
                /**
                 * @description 平台列表（逗号分隔），如 TIKTOK,SHOPEE
                 * @example TIKTOK
                 */
                platforms: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    publishTkCheck: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    list: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUserLinkAccountItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    queryDetail: {
        parameters: {
            query: {
                /** @description 收藏ID */
                collectionId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getProduct: {
        parameters: {
            query: {
                /**
                 * @description 商品主体 ID
                 * @example 3001
                 */
                productId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserProductResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    delete: {
        parameters: {
            query: {
                /** @description 收藏ID */
                id: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listUserAssets: {
        parameters: {
            query?: {
                /**
                 * @description 资产类型，不传则返回全部
                 * @example IMG
                 */
                assetType?: PathsApiUsersAssetsGetParametersQueryAssetType;
                /**
                 * @description 资产来源，不传则返回全部
                 * @example USER
                 */
                assetSource?: PathsApiUsersAssetsGetParametersQueryAssetSource;
                /** @description 页码，从 1 开始 */
                pageNo?: number;
                /** @description 每页条数 */
                pageSize?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultPageResultUserAssetItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listUserAssets_1: {
        parameters: {
            query?: {
                /**
                 * @description 资产类型，不传则返回全部
                 * @example VID
                 */
                assetType?: PathsApiUserAssetsGetParametersQueryAssetType;
                /**
                 * @description 资产来源，不传则返回全部
                 * @example USER
                 */
                assetSource?: PathsApiUserAssetsGetParametersQueryAssetSource;
                /** @description 页码，从 1 开始 */
                pageNo?: number;
                /** @description 每页条数 */
                pageSize?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultPageResultUserAssetItemV2Response"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listTrashAssets_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListUserAssetTrashItemResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    sellerAuthCallBack: {
        parameters: {
            query: {
                code: string;
                app_key?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCreatorAuthUrl: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoLinkedProduct: {
        parameters: {
            query: {
                /**
                 * @description 资产id
                 * @example 1
                 */
                assetId: number;
                /**
                 * @description 关联账号id
                 * @example 1
                 */
                linkId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultTkShopVideoProductResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listAccountProducts: {
        parameters: {
            query: {
                /**
                 * @description 关联账号id
                 * @example 1
                 */
                linkId: number;
                /**
                 * @description 每页大小
                 * @example 20
                 */
                pageSize?: number;
                /** @description 分页标识（首页可不传，后续页使用上一页返回的 nextPageToken） */
                pageToken?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultTkShopAccountProductPageResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getRefundQuota: {
        parameters: {
            query: {
                jobType: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultRefundQuotaResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    searchKalodataProducts: {
        parameters: {
            query: {
                /** @description 搜索关键词，可以输入 kalodata.com 链接 */
                keyword: string;
                /** @description 条数 */
                pageSize?: number;
            };
            header: {
                /**
                 * @description 国家Code
                 * @example US
                 */
                country: string;
            };
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListSearchTiktokProductResult"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    queryOrder: {
        parameters: {
            query: {
                orderId: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultOrderVO"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    goToPay: {
        parameters: {
            query: {
                token: string;
                language?: string;
                param: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    authCallBack: {
        parameters: {
            query: {
                code: string;
                app_key?: string;
                state?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getVideoCreationJobStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                jobId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserAiJobDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getQueueStatus: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCreationOption: {
        parameters: {
            query?: {
                /** @description 视频语言缩写（LanguageEnum.abbreviation），如 zh、en；当为中文/英文时会隐藏 15 秒下的 sd2f、sd2 */
                "video-language"?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVideoCreationOptionConfig"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getJobStatus: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                jobId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultUserAiJobDetailResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getImageOptions: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    poll: {
        parameters: {
            query: {
                /** @description Same seed used on the /cli-login page */
                seed: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultMapStringObject"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCredits: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultCreditBalanceResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getI18nVersion: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultString"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listProductsCollection: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListSimpleFocusProductResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getDevices: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultListDeviceInfo"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    listCreditLogs: {
        parameters: {
            query?: {
                /** @description 页码，从1开始 */
                pageNo?: number;
                /** @description 页大小 */
                pageSize?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultPageResultCreditLogResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    checkCredit: {
        parameters: {
            query: {
                /** @description 内容 ID */
                id: string;
                /** @description 内容类型 */
                type: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultCreditCheckResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCredits_1: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultCreditBalanceResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getCharacterAsset: {
        parameters: {
            query: {
                /**
                 * @description 角色资产 ID
                 * @example 3001
                 */
                assetId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultCharacterAssetResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    getAssetState: {
        parameters: {
            query: {
                /**
                 * @description 资产 ID（clip_user_asset.id）
                 * @example 1234567890
                 */
                assetId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultAssetStateResponse"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    isDownloaded: {
        parameters: {
            query: {
                /**
                 * @description 资产 ID（clip_user_asset.id）
                 * @example 1234567890
                 */
                assetId: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultBoolean"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
    emptyTrash: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description OK */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultInteger"];
                };
            };
            /** @description Bad Request */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"] | components["schemas"]["ResultMapStringString"];
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Conflict */
            409: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Too Many Requests */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Internal Server Error */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Bad Gateway */
            502: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
            /** @description Service Unavailable */
            503: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "*/*": components["schemas"]["ResultVoid"];
                };
            };
        };
    };
}
export enum PathsApiCharacterAssetsGetParametersQueryCategory {
    MODEL = "MODEL",
    ANIMAL = "ANIMAL"
}
export enum PathsApiVideoScriptAnalysisGetParametersQueryVideoSource {
    YouTube = "YouTube",
    Kalodata = "Kalodata",
    Instagram = "Instagram",
    TikTok = "TikTok",
    Kaloclip = "Kaloclip"
}
export enum PathsApiVideoVideoUrlGetParametersQueryVideoSource {
    YouTube = "YouTube",
    Kalodata = "Kalodata",
    Instagram = "Instagram",
    TikTok = "TikTok",
    Kaloclip = "Kaloclip"
}
export enum PathsApiVideoProductInfoGetParametersQueryVideoSource {
    YouTube = "YouTube",
    Kalodata = "Kalodata",
    Instagram = "Instagram",
    TikTok = "TikTok",
    Kaloclip = "Kaloclip"
}
export enum PathsApiVideoDownloadUrlGetParametersQueryVideoSource {
    YouTube = "YouTube",
    Kalodata = "Kalodata",
    Instagram = "Instagram",
    TikTok = "TikTok",
    Kaloclip = "Kaloclip"
}
export enum PathsApiVideoDetailGetParametersQueryVideoSource {
    YouTube = "YouTube",
    Kalodata = "Kalodata",
    Instagram = "Instagram",
    TikTok = "TikTok",
    Kaloclip = "Kaloclip"
}
export enum PathsApiUsersAssetsGetParametersQueryAssetType {
    IMG = "IMG",
    VID = "VID",
    AUD = "AUD"
}
export enum PathsApiUsersAssetsGetParametersQueryAssetSource {
    USER = "USER",
    AI = "AI",
    EXT = "EXT"
}
export enum PathsApiUserAssetsGetParametersQueryAssetType {
    IMG = "IMG",
    VID = "VID",
    AUD = "AUD"
}
export enum PathsApiUserAssetsGetParametersQueryAssetSource {
    USER = "USER",
    AI = "AI",
    EXT = "EXT"
}
export enum UserProductCategorySource {
    LINK = "LINK",
    AI = "AI",
    USER = "USER"
}
export enum UserProductImageSource {
    USER = "USER",
    KALODATA = "KALODATA",
    TIKTOK = "TIKTOK",
    AMAZON = "AMAZON"
}
export enum UserProductSellingPointSource {
    AI = "AI",
    USER = "USER",
    LINK = "LINK"
}
export enum UserProductUpsertRequestSourceType {
    MANUAL = "MANUAL",
    TIKTOK = "TIKTOK",
    AMAZON = "AMAZON",
    KALODATA = "KALODATA"
}
export enum UserProductResponseSourceType {
    MANUAL = "MANUAL",
    TIKTOK = "TIKTOK",
    AMAZON = "AMAZON",
    KALODATA = "KALODATA"
}
export enum CharacterAssetResponseCategory {
    MODEL = "MODEL",
    ANIMAL = "ANIMAL"
}
export enum CharacterAssetResponseBindState {
    NONE = "NONE",
    BINDING = "BINDING",
    BOUND = "BOUND",
    FAILED = "FAILED"
}
export enum VideoRemakeRequestVideoSource {
    TikTok = "TikTok",
    Kalodata = "Kalodata",
    YouTube = "YouTube",
    Instagram = "Instagram",
    Kaloclip = "Kaloclip"
}
export enum VideoRemakeRequestAspectRatio {
    RATIO_9_16 = "RATIO_9_16",
    RATIO_16_9 = "RATIO_16_9"
}
export enum VideoRemakeRequestQuantity {
    Value1 = "1"
}
export enum VideoRemakeRequestResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P"
}
export enum VideoRemakeRequestInternalModelId {
    sd2f = "sd2f",
    sd2 = "sd2"
}
export enum VideoRemakeCreditPreviewRequestVideoSource {
    TikTok = "TikTok",
    Kalodata = "Kalodata",
    YouTube = "YouTube",
    Instagram = "Instagram",
    Kaloclip = "Kaloclip"
}
export enum VideoRemakeCreditPreviewRequestResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P"
}
export enum BuildVideoReferenceScriptRequestInternalModelId {
    v31 = "v31",
    sr2l = "sr2l",
    sr2 = "sr2",
    sd2f = "sd2f",
    sd2 = "sd2",
    sr20 = "sr20"
}
export enum VideoRecreationRequestInternalModelId {
    v31 = "v31",
    sr2l = "sr2l",
    sr2 = "sr2",
    sd2f = "sd2f",
    sd2 = "sd2",
    sr20 = "sr20"
}
export enum VideoCreationRequestAspectRatio {
    RATIO_9_16 = "RATIO_9_16",
    RATIO_16_9 = "RATIO_16_9"
}
export enum VideoCreationRequestDuration {
    Value8 = "8",
    Value12 = "12",
    Value15 = "15",
    Value20 = "20"
}
export enum VideoCreationRequestQuantity {
    Value1 = "1"
}
export enum VideoCreationRequestResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P",
    Value4K = "4K"
}
export enum VideoCreationRequestInternalModelId {
    v31 = "v31",
    sr2l = "sr2l",
    sr2 = "sr2",
    sd2f = "sd2f",
    sd2 = "sd2",
    sr20 = "sr20"
}
export enum BaseVideoCreationOptionRequestAspectRatio {
    RATIO_9_16 = "RATIO_9_16",
    RATIO_16_9 = "RATIO_16_9"
}
export enum BaseVideoCreationOptionRequestDuration {
    Value8 = "8",
    Value12 = "12",
    Value15 = "15",
    Value20 = "20"
}
export enum BaseVideoCreationOptionRequestQuantity {
    Value1 = "1"
}
export enum BaseVideoCreationOptionRequestResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P",
    Value4K = "4K"
}
export enum BaseVideoCreationOptionRequestInternalModelId {
    v31 = "v31",
    sr2l = "sr2l",
    sr2 = "sr2",
    sd2f = "sd2f",
    sd2 = "sd2",
    sr20 = "sr20"
}
export enum UserPublishSubmitRequestPublishMode {
    NOW = "NOW",
    SCHEDULE = "SCHEDULE"
}
export enum UserCollectionRequestType {
    Value1 = "1",
    Value2 = "2"
}
export enum ResubmitAiJobRequestInternalModelId {
    v31 = "v31",
    sr2l = "sr2l",
    sr2 = "sr2",
    sd2f = "sd2f",
    sd2 = "sd2",
    sr20 = "sr20"
}
export enum IssueReportSubmitRequestJobType {
    VIDEO_CREATION = "VIDEO_CREATION"
}
export enum ProductInfoByLinkResponseLinkSource {
    KALODATA = "KALODATA",
    TIKTOK = "TIKTOK",
    AMAZON = "AMAZON"
}
export enum LoginRequestLoginMethod {
    PASSWORD = "PASSWORD",
    EMAIL_PASSWORD = "EMAIL_PASSWORD",
    EMAIL = "EMAIL",
    SMS = "SMS",
    GOOGLE = "GOOGLE"
}
export enum VideoScriptAnalysisDownloadRequestVideoSource {
    TikTok = "TikTok",
    Kalodata = "Kalodata"
}
export enum CharacterAssetCreateFormRequestCategory {
    MODEL = "MODEL",
    ANIMAL = "ANIMAL"
}
export enum VideoUrlResponseStatus {
    Value0 = "0",
    Value1 = "1",
    Value2 = "2"
}
export enum AiJobInputResponseResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P",
    Value4K = "4K"
}
export enum AiJobInputResponseAspectRatio {
    RATIO_9_16 = "RATIO_9_16",
    RATIO_16_9 = "RATIO_16_9"
}
export enum VideoCreationJobInputResponseAspectRatio {
    RATIO_9_16 = "RATIO_9_16",
    RATIO_16_9 = "RATIO_16_9"
}
export enum VideoCreationJobInputResponseResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P",
    Value4K = "4K"
}
export enum VideoRemakeJobInputResponseAspectRatio {
    RATIO_9_16 = "RATIO_9_16",
    RATIO_16_9 = "RATIO_16_9"
}
export enum VideoRemakeJobInputResponseResolution {
    Value480P = "480P",
    Value720P = "720P",
    Value1080P = "1080P",
    Value4K = "4K"
}
export enum VideoRemakeJobInputResponseVideoSource {
    TikTok = "TikTok",
    Kalodata = "Kalodata",
    YouTube = "YouTube",
    Instagram = "Instagram",
    Kaloclip = "Kaloclip"
}
export enum UserAiJobItemResponseJobType {
    VIDEO_CREATION = "VIDEO_CREATION",
    VIDEO_REMAKE = "VIDEO_REMAKE",
    VIDEO_SCRIPT_GENERATE = "VIDEO_SCRIPT_GENERATE",
    VIDEO_ANALYSIS = "VIDEO_ANALYSIS"
}
export enum UserAiJobItemResponseStatus {
    processing = "processing",
    queued = "queued",
    completed = "completed",
    failed = "failed"
}
export enum UserAssetItemResponseAssetType {
    IMG = "IMG",
    VID = "VID",
    AUD = "AUD"
}
export enum UserAssetItemResponseAssetSource {
    USER = "USER",
    AI = "AI",
    EXT = "EXT"
}
export enum UserAssetItemResponseVideoPublishStatus {
    PENDING_PUBLISH = "PENDING_PUBLISH",
    SUCCESS = "SUCCESS"
}
export enum UserPublishResultResponsePlatform {
    TIKTOK = "TIKTOK"
}
export enum UserPublishResultResponsePublishMode {
    NOW = "NOW",
    SCHEDULE = "SCHEDULE"
}
export enum UserPublishResultResponseStatus {
    INIT = "INIT",
    UPLOADING = "UPLOADING",
    PRE_CHECKING = "PRE_CHECKING",
    PRE_CHECK_SUCCESS = "PRE_CHECK_SUCCESS",
    PENDING_PUBLISH = "PENDING_PUBLISH",
    PRE_CHECK_FAIL = "PRE_CHECK_FAIL",
    PUBLISHING = "PUBLISHING",
    SUCCESS = "SUCCESS",
    FAIL = "FAIL",
    CANCEL = "CANCEL"
}
export enum UserLinkAccountItemResponsePlatform {
    TIKTOK = "TIKTOK"
}
export enum UserAssetItemV2ResponseAssetType {
    IMG = "IMG",
    VID = "VID",
    AUD = "AUD"
}
export enum UserAssetItemV2ResponseAssetSource {
    USER = "USER",
    AI = "AI",
    EXT = "EXT"
}
export enum VidExtraVideoPublishStatus {
    PENDING_PUBLISH = "PENDING_PUBLISH",
    SUCCESS = "SUCCESS"
}
export enum UserAssetTrashItemResponseAssetType {
    IMG = "IMG",
    VID = "VID",
    AUD = "AUD"
}
export enum UserAssetTrashItemResponseAssetSource {
    USER = "USER",
    AI = "AI",
    EXT = "EXT"
}
export enum RefundQuotaResponseJobType {
    PRODUCT_ATTRIBUTE = "PRODUCT_ATTRIBUTE",
    VIDEO_ANALYSIS = "VIDEO_ANALYSIS",
    VIDEO_SCRIPT_GENERATE = "VIDEO_SCRIPT_GENERATE",
    VIDEO_CREATION = "VIDEO_CREATION",
    VIDEO_EDITING = "VIDEO_EDITING"
}
export enum DeviceInfoDeviceClass {
    DESKTOP = "DESKTOP",
    ANONYMIZED = "ANONYMIZED",
    MOBILE = "MOBILE",
    TABLET = "TABLET",
    PHONE = "PHONE",
    WATCH = "WATCH",
    AUGMENTED_REALITY = "AUGMENTED_REALITY",
    VIRTUAL_REALITY = "VIRTUAL_REALITY",
    E_READER = "E_READER",
    SET_TOP_BOX = "SET_TOP_BOX",
    TV = "TV",
    GAME_CONSOLE = "GAME_CONSOLE",
    HANDHELD_GAME_CONSOLE = "HANDHELD_GAME_CONSOLE",
    HOME_APPLIANCE = "HOME_APPLIANCE",
    VOICE = "VOICE",
    SMART_DISPLAY = "SMART_DISPLAY",
    CAR = "CAR",
    CLOUD = "CLOUD",
    ROBOT = "ROBOT",
    ROBOT_MOBILE = "ROBOT_MOBILE",
    ROBOT_IMITATOR = "ROBOT_IMITATOR",
    HACKER = "HACKER",
    UNKNOWN = "UNKNOWN",
    UNCLASSIFIED = "UNCLASSIFIED"
}
